import * as CONSTANT from './../base/constant';
import { createElement, detach, prepend, append, attributes, Browser, addClass, removeClass } from '@syncfusion/ej2-base';
import { markerClassName } from './dom-node';
import * as EVENTS from './../../common/constant';
import { setStyleAttribute } from '@syncfusion/ej2-base';
import { isIDevice, setEditFrameFocus } from '../../common/util';
import { isNullOrUndefined, isNullOrUndefined as isNOU, closest } from '@syncfusion/ej2-base';
import { InsertHtml } from './inserthtml';
import { DOMMethods } from './dom-tree';
/**
 * Lists internal component
 *
 * @hidden
 * @private
 */
var Lists = /** @class */ (function () {
    /**
     * Constructor for creating the Lists plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden
     * @private
     */
    function Lists(parent) {
        this.listTabIndentation = false;
        this.parent = parent;
        this.domNode = this.parent.domNode;
        this.addEventListener();
    }
    Lists.prototype.addEventListener = function () {
        this.parent.observer.on(EVENTS.LIST_TYPE, this.applyListsHandler, this);
        this.parent.observer.on(EVENTS.KEY_UP_HANDLER, this.onKeyUp, this);
        this.parent.observer.on(EVENTS.KEY_DOWN_HANDLER, this.keyDownHandler, this);
        this.parent.observer.on(EVENTS.SPACE_ACTION, this.spaceKeyAction, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    };
    Lists.prototype.removeEventListener = function () {
        this.parent.observer.off(EVENTS.LIST_TYPE, this.applyListsHandler);
        this.parent.observer.off(EVENTS.KEY_UP_HANDLER, this.onKeyUp);
        this.parent.observer.off(EVENTS.KEY_DOWN_HANDLER, this.keyDownHandler);
        this.parent.observer.off(EVENTS.SPACE_ACTION, this.spaceKeyAction);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    };
    Lists.prototype.testList = function (elem) {
        var olListRegex = [/^[\d]+[.]+$/,
            /^(?=[MDCLXVI])M*(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})[.]$/gi,
            /^[a-zA-Z][.]+$/];
        var elementStart = !isNullOrUndefined(elem) ? elem.innerText.trim().split('.')[0] + '.' : null;
        if (!isNullOrUndefined(elementStart)) {
            for (var i = 0; i < olListRegex.length; i++) {
                if (olListRegex[i].test(elementStart)) {
                    return true;
                }
            }
        }
        return false;
    };
    Lists.prototype.isOrderedList = function (range) {
        var olListStartRegex = [/^[1]+[.]+$/, /^[i]+[.]+$/, /^[a]+[.]+$/];
        if (!isNullOrUndefined(range.startContainer.textContent.slice(0, range.startOffset))) {
            var editorValue = range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim();
            for (var i = 0; i < olListStartRegex.length; i++) {
                if (olListStartRegex[i].test(editorValue) && editorValue.length === 2) {
                    return true;
                }
            }
        }
        return false;
    };
    Lists.prototype.isUnOrderedList = function (range) {
        var ulListStartRegex = [/^[*]$/, /^[-]$/];
        if (!isNullOrUndefined(range.startContainer.textContent.slice(0, range.startOffset))) {
            var editorValue = range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim();
            for (var i = 0; i < ulListStartRegex.length; i++) {
                if (ulListStartRegex[i].test(editorValue)) {
                    return true;
                }
            }
        }
        return false;
    };
    Lists.prototype.isCheckList = function (range) {
        // Updated regex to match checkbox patterns with at most one space: [], [x], [ ], [x ], [ x], [ x ]
        var ulListStartRegex = [/^\[\s?\]$/, /^\[\s?x\s?\]$/i];
        if (!isNullOrUndefined(range.startContainer.textContent.slice(0, range.startOffset))) {
            var editorValue = range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim();
            for (var i = 0; i < ulListStartRegex.length; i++) {
                if (ulListStartRegex[i].test(editorValue)) {
                    return true;
                }
            }
        }
        return false;
    };
    Lists.prototype.createAutoList = function (enterKey, shiftEnterKey) {
        var autoListRules = {
            BR: { BR: true, P: true, DIV: true },
            P: { BR: false, P: true, DIV: true },
            DIV: { BR: false, P: true, DIV: true }
        };
        if (autoListRules[enterKey] && autoListRules[enterKey][shiftEnterKey] !== undefined) {
            return autoListRules[enterKey][shiftEnterKey];
        }
        return false;
    };
    Lists.prototype.isInsideSameListType = function (startNode, range) {
        if (!startNode) {
            return false;
        }
        // Find the closest <li> ancestor of the startNode
        var listItem = startNode.closest('li');
        if (!listItem) {
            return false; // Not inside a list item
        }
        // Get the parent list element (either <ul> or <ol>)
        var parentList = listItem.closest('ul, ol');
        if (!parentList) {
            return false; // No valid list container found
        }
        // Check if parentList is OL or UL and compare with startElementOLTest
        if (this.isOrderedList(range) && parentList.tagName === 'OL') {
            return true;
        }
        else if (this.isUnOrderedList(range) && parentList.tagName === 'UL' && !parentList.classList.contains('e-rte-checklist')) {
            return true;
        }
        else if (this.isCheckList(range) && parentList.tagName === 'UL' && parentList.classList.contains('e-rte-checklist')) {
            return true;
        }
        else {
            return false;
        }
    };
    Lists.prototype.spaceList = function (e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        // eslint-disable-next-line
        var endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        var preElement = startNode.previousElementSibling;
        var nextElement = startNode.nextElementSibling;
        var preElemULStart = !isNullOrUndefined(preElement) ?
            preElement.innerText.trim().substring(0, 1) : null;
        var nextElemULStart = !isNullOrUndefined(nextElement) ?
            nextElement.innerText.trim().substring(0, 1) : null;
        var startElementOLTest = this.isOrderedList(range);
        var preElementOLTest = this.testList(preElement);
        var nextElementOLTest = this.testList(nextElement);
        var isInsideSameListType = this.isInsideSameListType(startNode, range);
        var nextElementBRTest = range.startContainer.previousElementSibling && range.startContainer.previousElementSibling.tagName === 'BR';
        if (!isInsideSameListType && !preElementOLTest && !nextElementOLTest && preElemULStart !== '*' && nextElemULStart !== '*' && (this.createAutoList(e.enterKey, e.shiftEnterKey) || !nextElementBRTest)) {
            var brElement = createElement('br');
            if (startElementOLTest) {
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === '#text' && range.startContainer.textContent.length === 0) {
                    this.parent.domNode.insertAfter(brElement, range.startContainer);
                }
                this.applyListsHandler({ subCommand: 'OL', callBack: e.callBack, enterAction: e.enterKey });
                e.event.preventDefault();
            }
            else if (range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim() === '*' ||
                range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim() === '-') {
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === '#text' && range.startContainer.textContent.length === 0) {
                    this.parent.domNode.insertAfter(brElement, range.startContainer);
                }
                this.applyListsHandler({ subCommand: 'UL', callBack: e.callBack, enterAction: e.enterKey });
                e.event.preventDefault();
            }
            else if (this.isCheckList(range)) {
                var isChecked = /^\[\s*x\s*\]$/i.test(range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim());
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === '#text' && range.startContainer.textContent.length === 0) {
                    this.parent.domNode.insertAfter(brElement, range.startContainer);
                }
                this.applyListsHandler({ subCommand: 'Checklist', callBack: e.callBack, enterAction: e.enterKey }, isChecked);
                e.event.preventDefault();
            }
        }
    };
    Lists.prototype.isCtrlEnterInChecklist = function (e) {
        var storeIntoStack = false;
        if (e.event && (e.event.ctrlKey || e.event.metaKey) && e.event.key === 'Enter' && e.event.action === 'checklist-toggle') {
            var domMethods = new DOMMethods(this.parent.editableElement);
            var li = domMethods.getLiElementsInRange();
            for (var i = 0; i < li.length; i++) {
                if (li[i].nodeName === 'LI' && li[i].parentElement.nodeName === 'UL'
                    && !li[i].classList.contains('e-rte-checklist-hidden')
                    && li[i].parentElement.classList.contains('e-rte-checklist')) {
                    storeIntoStack = true;
                    if (li[i].classList.contains('e-rte-checklist-checked')) {
                        li[i].classList.remove('e-rte-checklist-checked');
                    }
                    else {
                        li[i].classList.add('e-rte-checklist-checked');
                    }
                }
            }
        }
        if (storeIntoStack) {
            if (e.callBack) {
                e.callBack({
                    requestType: this.currentAction,
                    editorMode: 'HTML',
                    range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                    elements: this.parent.domNode.blockNodes(),
                    event: e.event
                });
            }
            storeIntoStack = false;
        }
    };
    Lists.prototype.enterList = function (e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var startNode = range.startContainer.nodeName === 'LI' ? range.startContainer :
            range.startContainer.parentElement.closest('LI');
        var endNode = range.endContainer.nodeName === 'LI' ? range.endContainer :
            range.endContainer.parentElement.closest('LI');
        // Command handler for Ctrl+Enter or Cmd+Enter checklist toggle
        this.isCtrlEnterInChecklist(e);
        var hasMediaElem = false;
        if (!isNOU(startNode)) {
            var videoElemList = startNode.querySelectorAll('.e-video-clickelem');
            var embedVideoElem = videoElemList.length > 0 && videoElemList[0].childNodes[0].nodeName === 'IFRAME';
            hasMediaElem = startNode.querySelectorAll('IMG').length > 0 || startNode.querySelectorAll('AUDIO').length > 0 || startNode.querySelectorAll('VIDEO').length > 0 || embedVideoElem;
        }
        var startNodeParent;
        var parentOfCurrentOLUL;
        if (startNode) {
            startNodeParent = startNode.parentElement;
            if (startNodeParent) {
                parentOfCurrentOLUL = startNodeParent.parentElement;
            }
        }
        var tableElement = !isNullOrUndefined(startNode) ? startNode.querySelector('TABLE') : null;
        if (!isNOU(startNode) && !isNOU(endNode) && startNode === endNode && startNode.tagName === 'LI' &&
            startNode.textContent.trim() === '' && !hasMediaElem && isNOU(tableElement)) {
            if (startNode.innerHTML.indexOf('&nbsp;') >= 0) {
                return;
            }
            if (startNode.textContent.charCodeAt(0) === 65279) {
                startNode.textContent = '';
            }
            if (isNOU(parentOfCurrentOLUL.closest('UL')) && isNOU(parentOfCurrentOLUL.closest('OL'))) {
                if (!isNOU(startNode.nextElementSibling)) {
                    var nearBlockNode = this.parent.domNode.blockParentNode(startNode);
                    this.parent.nodeCutter.GetSpliceNode(range, nearBlockNode);
                }
                var insertTag = void 0;
                if (e.enterAction === 'DIV') {
                    insertTag = createElement('div');
                    insertTag.innerHTML = '<br>';
                }
                else if (e.enterAction === 'P') {
                    insertTag = createElement('p');
                    insertTag.innerHTML = '<br>';
                }
                else {
                    insertTag = createElement('br');
                }
                var immediateBlock = this.domNode.getImmediateBlockNode(range.startContainer);
                var _a = this.applyFormattingFromRange(insertTag, range, immediateBlock, e.enterAction), formattedElement = _a.formattedElement, cursorTarget = _a.cursorTarget;
                insertTag = formattedElement;
                if (!isNOU(parentOfCurrentOLUL) && parentOfCurrentOLUL.nodeName === 'BLOCKQUOTE') {
                    this.parent.observer.notify('blockquote_list_handled', {});
                }
                this.parent.domNode.insertAfter(insertTag, startNodeParent);
                e.event.preventDefault();
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, cursorTarget, 0);
                if (startNodeParent.textContent === '' && (startNodeParent.querySelectorAll('audio,video,table').length === 0)) {
                    detach(startNodeParent);
                }
                else {
                    detach(startNode);
                }
            }
            // To handle the nested enter key press in the list for the first LI element
            if (!isNOU(parentOfCurrentOLUL) && (!isNOU(parentOfCurrentOLUL.closest('UL')) || !isNOU(parentOfCurrentOLUL.closest('OL'))) &&
                parentOfCurrentOLUL.nodeName === 'LI' && parentOfCurrentOLUL.style.listStyleType === 'none' &&
                parentOfCurrentOLUL.textContent === '' && startNode.textContent === '' && startNode === startNodeParent.firstElementChild &&
                isNOU(startNode.nextSibling)) {
                detach(startNodeParent);
                parentOfCurrentOLUL.style.removeProperty('list-style-type');
                e.event.preventDefault();
            }
        }
        var startContainer = range.startContainer.nodeName === '#text' ? range.startContainer.parentElement : range.startContainer;
        var isCloseTableOrEditableElem = this.isNodeInListNotTable(startContainer);
        if (!isNOU(startNode) && !isNOU(endNode) && startNode === endNode && startNode.tagName === 'LI' && startNode.textContent.length !== 0 && isCloseTableOrEditableElem && e.event && !e.event.shiftKey && !(e.event.ctrlKey || e.event.metaKey)) {
            this.splitListAtCursor(range, startNode, startNodeParent);
            e.event.preventDefault();
            return;
        }
        this.handleNestedEnterKeyForLists(e, parentOfCurrentOLUL, startNode, startNodeParent);
    };
    /*
    * Splits a list item at the cursor position, creating a new list item with content after the cursor.
    * This method handles both simple and complex list structures, including nested lists.
    */
    Lists.prototype.splitListAtCursor = function (range, startNode, startNodeParent) {
        var newRange = this.parent.editableElement.ownerDocument.createRange();
        var selfClosingElements = ['AREA', 'BASE', 'BR', 'COL', 'EMBED', 'HR', 'IMG', 'INPUT', 'LINK', 'META', 'SOURCE', 'TRACK', 'WBR'];
        var startContainer = range.startContainer;
        var startOffset = range.startOffset;
        var clonedContent;
        if (range.startContainer === range.endContainer && range.startOffset === range.endOffset) {
            newRange.setStart(startContainer, startOffset);
            newRange.setEndAfter(startNode);
            this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
            var getNewRange = this.parent.nodeSelection.getRange(this.parent.editableElement.ownerDocument);
            clonedContent = getNewRange.cloneContents();
            this.cleanupListElements(clonedContent, selfClosingElements);
            newRange.deleteContents();
        }
        else {
            range.deleteContents();
            newRange.setStart(startContainer, startOffset);
            newRange.setEndAfter(startNode);
            this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
            var getNewRange = this.parent.nodeSelection.getRange(this.parent.editableElement.ownerDocument);
            clonedContent = getNewRange.cloneContents();
            this.cleanupListElements(clonedContent, selfClosingElements);
            newRange.deleteContents();
        }
        if (startNode.querySelectorAll('*:empty').length > 0) {
            var emptyElem = startNode.querySelectorAll('*:empty');
            for (var i = 0; i < emptyElem.length; i++) {
                if (selfClosingElements.indexOf(emptyElem[i].nodeName) === -1) {
                    detach(emptyElem[i]);
                }
            }
        }
        if (startNode.innerHTML === '') {
            startNode.innerHTML = '<br>';
        }
        clonedContent.normalize();
        var firstPosition = this.parent.nodeSelection.findFirstContentNode(clonedContent);
        if (startNode.nextElementSibling) {
            startNodeParent.insertBefore(clonedContent, startNode.nextElementSibling);
        }
        else {
            startNodeParent.appendChild(clonedContent);
        }
        if (firstPosition.node.nodeName === 'BR') {
            var newRange_1 = this.parent.editableElement.ownerDocument.createRange();
            newRange_1.setStartBefore(firstPosition.node);
            newRange_1.setEndBefore(firstPosition.node);
            this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange_1);
        }
        else {
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, firstPosition.node, 0);
        }
    };
    /*
    * Cleans up empty elements within list content and ensures proper structure.
    * This method removes empty elements and adds necessary <br> elements for proper display.
    */
    Lists.prototype.cleanupListElements = function (content, selfClosingElements) {
        // Find and remove empty elements
        var liElement = content.firstElementChild;
        var emptyElement = liElement.querySelectorAll('*:empty');
        for (var i = 0; i < emptyElement.length - 1; i++) {
            if (selfClosingElements.indexOf(emptyElement[i].nodeName) === -1) {
                detach(emptyElement[i]);
            }
        }
        this.ensureListItemContent(content);
    };
    /*
     * Ensures list items have proper content by adding <br> elements to empty list items or to list items that only contain nested lists.
     */
    Lists.prototype.ensureListItemContent = function (content) {
        var listItems = content.querySelectorAll('li');
        for (var i = 0; i < listItems.length; i++) {
            var li = listItems[i];
            // Check if list item has no text content or only contains nested lists
            var hasOnlyLists = li.childNodes.length > 0 && ((li.firstChild &&
                (li.firstChild.nodeName === 'UL' || li.firstChild.nodeName === 'OL')) ||
                (li.firstElementChild && (li.firstElementChild.nodeName === 'UL' || li.firstElementChild.nodeName === 'OL'))) &&
                !(li.firstChild && li.firstChild.nodeName === '#text' && li.firstChild.textContent.trim().length > 0);
            if (hasOnlyLists || li.innerHTML === '') {
                var brElement = document.createElement('br');
                if (li.firstChild) {
                    li.insertBefore(brElement, li.firstChild);
                }
                else {
                    li.appendChild(brElement);
                }
            }
            else {
                var emptyElement = li.querySelector('*:empty');
                if (emptyElement) {
                    emptyElement.appendChild(document.createElement('br'));
                }
            }
        }
    };
    /*
     * Checks if a node is inside a table or list element.
     * Returns true if the node is inside a list and not inside a table.
     * Returns false if the node is inside a table or not inside a list element.
     */
    Lists.prototype.isNodeInListNotTable = function (node) {
        var currentNode = node;
        // Traverse up the DOM tree until reaching the editable element or body
        while (currentNode && currentNode !== this.parent.editableElement) {
            if (currentNode.nodeName === 'TABLE') {
                // If a table is found, return false regardless of whether a list is found or not
                return false;
            }
            else if ((currentNode.nodeName === 'UL' || currentNode.nodeName === 'OL')) {
                // Mark that we found a list element
                return true;
            }
            currentNode = currentNode.parentNode;
        }
        // Return true only if a list was found and no table was encountered
        return false;
    };
    Lists.prototype.applyFormattingFromRange = function (element, range, blockNode, enterAction) {
        var cursorTarget = element;
        var formatTags = [];
        if (blockNode) {
            var currentNode = range.startContainer;
            var blockElements = ['div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'ul', 'ol', 'table', 'tr', 'td', 'th'];
            while (currentNode && currentNode !== blockNode) {
                var nodeName = currentNode.nodeName.toLowerCase();
                if (blockElements.indexOf(nodeName) === -1 && currentNode.nodeType === Node.ELEMENT_NODE) {
                    formatTags.push({
                        tag: nodeName,
                        element: currentNode
                    });
                }
                currentNode = currentNode.parentNode;
            }
            if (formatTags.length > 0) {
                element = (enterAction === 'BR') ? createElement('DIV') : element;
                element.innerHTML = '';
                var currentElement_1 = element;
                formatTags.reverse().forEach(function (format) {
                    var newElement = createElement(format.tag);
                    Array.from(format.element.attributes).forEach(function (attr) {
                        newElement.setAttribute(attr.name, attr.value);
                    });
                    currentElement_1.appendChild(newElement);
                    currentElement_1 = newElement;
                });
                var brElement = createElement('br');
                currentElement_1.appendChild(brElement);
                cursorTarget = currentElement_1;
            }
        }
        return { formattedElement: (enterAction === 'BR' && formatTags.length > 0) ? element.firstChild : element, cursorTarget: cursorTarget };
    };
    Lists.prototype.handleNestedEnterKeyForLists = function (e, parentOfCurrentOLUL, startNode, startNodeParent) {
        var hasIgnoredElement = false;
        if (!isNOU(startNode) && startNode.querySelectorAll('audio,video,table,img,HR').length > 0) {
            hasIgnoredElement = true;
        }
        if (!isNOU(parentOfCurrentOLUL) && (!isNOU(parentOfCurrentOLUL.closest('UL')) || !isNOU(parentOfCurrentOLUL.closest('OL')) || startNodeParent.nodeName === 'UL' || startNodeParent.nodeName === 'OL') &&
            (parentOfCurrentOLUL.nodeName === 'LI' || startNode.nodeName === 'LI') && (parentOfCurrentOLUL.style.listStyleType === 'none' || parentOfCurrentOLUL.style.listStyleType === '') &&
            parentOfCurrentOLUL.textContent !== '' && (!isNOU(startNode.lastElementChild) && startNode.lastElementChild.textContent !== '') && startNode.firstElementChild && (startNode.firstElementChild.textContent === '' && !hasIgnoredElement) && (startNode === startNodeParent.firstElementChild || startNode.nodeName === 'LI')) {
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            this.domNode.setMarker(this.saveSelection);
            e.event.preventDefault();
            var nodes = [];
            if (startNode === startNodeParent.firstElementChild) {
                nodes.push(startNodeParent.firstElementChild);
            }
            else if (startNode.nodeName === 'LI') {
                nodes.push(startNode);
            }
            this.revertList(nodes, e);
            this.revertClean();
            this.saveSelection = this.domNode.saveMarker(this.saveSelection);
            this.saveSelection.restore();
        }
    };
    Lists.prototype.backspaceList = function (e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        var endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        startNode = startNode.nodeName === 'BR' ? startNode.parentElement : startNode;
        endNode = endNode.nodeName === 'BR' ? endNode.parentElement : endNode;
        if (!isNOU(startNode) && startNode.closest('li')) {
            var listCursorInfo = this.getListCursorInfo(range);
            var isFirst = startNode.previousElementSibling === null;
            var allowedCursorSelections = ['StartParent'];
            var allowedSelections = ['SingleFull', 'MultipleFull'];
            var blockNodes = this.parent.domNode.blockNodes();
            var isAllListSelected = this.isAllListNodesSelected(startNode.closest('li').parentElement);
            var hasIndent = listCursorInfo.position === 'StartNested' && startNode && startNode.parentElement &&
                startNode.parentElement.closest('li') && startNode.parentElement.closest('li').getAttribute('style')
                && startNode.parentElement.closest('li').getAttribute('style').indexOf('list-style-type: none;') !== -1;
            if (isFirst && (allowedCursorSelections.indexOf(listCursorInfo.position) > -1 || hasIndent)) {
                e.event.preventDefault();
                var saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
                this.domNode.setMarker(saveSelection);
                for (var i = 0; i < blockNodes.length; i++) {
                    if (blockNodes.length > 0 && blockNodes[i].tagName !== 'LI'
                        && blockNodes[i].parentNode.tagName === 'LI') {
                        blockNodes[i] = blockNodes[i].parentNode;
                    }
                }
                this.revertList([blockNodes[0]], e);
                this.revertClean();
                saveSelection = this.domNode.saveMarker(saveSelection);
                saveSelection.restore();
                return;
            }
            else if (allowedSelections.indexOf(listCursorInfo.selectionState) > -1 && isAllListSelected) {
                e.event.preventDefault();
                blockNodes[0].innerHTML = '';
                range.deleteContents();
                if (blockNodes.length > 1) {
                    for (var i = 0; i < blockNodes.length; i++) {
                        if (i === 0) {
                            continue; // First List is needed after the removal of list items.
                        }
                        var list = blockNodes[i];
                        detach(list);
                    }
                }
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, blockNodes[0], 0);
                return;
            }
        }
        if (startNode === endNode && !isNullOrUndefined(closest(startNode, 'li')) &&
            ((startNode.textContent.trim() === '' && startNode.textContent.charCodeAt(0) === 65279) ||
                (startNode.textContent.length === 1 && startNode.textContent.charCodeAt(0) === 8203))) {
            startNode.textContent = '';
        }
        if (startNode === endNode && startNode.tagName === 'LI' && startNode.textContent.length === 0 &&
            isNOU(startNode.previousElementSibling)) {
            startNode.removeAttribute('style');
        }
        if (startNode === endNode && startNode.textContent === '' && !this.hasMediaElement(startNode)) {
            if (startNode.parentElement.tagName === 'LI' && endNode.parentElement.tagName === 'LI') {
                detach(startNode);
            }
            else if (startNode.closest('ul') || startNode.closest('ol')) {
                var parentList = !isNOU(startNode.closest('ul')) ? startNode.closest('ul') : startNode.closest('ol');
                if (parentList.firstElementChild === startNode && !isNOU(parentList.children[1]) &&
                    (parentList.children[1].tagName === 'OL' || parentList.children[1].tagName === 'UL')) {
                    if (parentList.tagName === parentList.children[1].tagName) {
                        while (parentList.children[1].lastChild) {
                            this.parent.domNode.insertAfter(parentList.children[1].lastChild, parentList.children[1]);
                        }
                        detach(parentList.children[1]);
                    }
                    else {
                        parentList.parentElement.insertBefore(parentList.children[1], parentList);
                    }
                }
            }
        }
        else if (!isNOU(startNode.firstChild) && startNode.firstChild.nodeName === 'BR' &&
            (!isNullOrUndefined(startNode.childNodes[1]) && (startNode.childNodes[1].nodeName === 'UL' ||
                startNode.childNodes[1].nodeName === 'OL'))) {
            var parentList = !isNOU(startNode.closest('ul')) ? startNode.closest('ul') : startNode.closest('ol');
            if (!isNOU(parentList) && parentList.tagName === startNode.childNodes[1].nodeName) {
                while (startNode.childNodes[1].lastChild) {
                    this.parent.domNode.insertAfter(startNode.children[1].lastChild, startNode);
                }
                detach(startNode.childNodes[1]);
            }
            else if (!isNOU(parentList)) {
                parentList.parentElement.insertBefore(startNode.children[1], parentList);
            }
        }
        if (startNode === endNode && startNode.tagName === 'LI' && this.isAtListStart(startNode, range) && !isNOU(startNode.closest('ul, ol'))) {
            var currentList = startNode.closest('ul, ol');
            var parentListItem = currentList.parentElement;
            var prevSibling = startNode.previousElementSibling;
            var nestedList = startNode.querySelector('ol, ul');
            if ((!isNOU(parentListItem) && parentListItem.tagName === 'LI' && !isNOU(currentList.previousSibling)) || (!isNOU(prevSibling) && prevSibling.nodeName === 'LI')) {
                if (!isNOU(nestedList) && (isNOU(prevSibling) || !isNOU(prevSibling))) {
                    e.event.preventDefault();
                    // Preventing a default content editable div behaviour and Handles rearrangement of nested lists when press the backspace while the cursor is at the nested list structure and also redistributes child nodes and maintains cursor position after rearrangement
                    this.handleNestedListRearrangement(startNode, currentList, parentListItem, prevSibling, nestedList);
                }
            }
        }
        this.removeList(range, e);
        this.firstListBackSpace(range, e);
    };
    Lists.prototype.hasMediaElement = function (element) {
        if (!element) {
            return false;
        }
        var videoElemList = element.querySelectorAll('.e-video-clickelem');
        var embedVideoElem = videoElemList.length > 0 && videoElemList[0].childNodes[0].nodeName === 'IFRAME';
        if (element.querySelectorAll('audio,video,table,img,hr').length > 0 || ['AUDIO', 'VIDEO', 'TABLE', 'IMG', 'HR'].indexOf(element.tagName) !== -1 || embedVideoElem) {
            return true;
        }
        return false;
    };
    Lists.prototype.handleNestedListRearrangement = function (startNode, currentList, parentListItem, prevSibling, nestedList) {
        var cursorOffset = this.parent.nodeSelection.findLastTextPosition(!isNOU(prevSibling) ? prevSibling : currentList.previousSibling);
        var childNodes = Array.from(startNode.childNodes);
        for (var i = 0; i < childNodes.length; i++) {
            var child = childNodes[i];
            if (child === nestedList && nestedList) {
                while (nestedList.firstChild) {
                    currentList.insertBefore(nestedList.firstChild, startNode);
                    var emptyOL = startNode.querySelector('OL:empty,UL:empty');
                    if (emptyOL) {
                        startNode.remove();
                    }
                }
            }
            else {
                if (!isNOU(prevSibling)) {
                    cursorOffset.node.parentElement.closest('li').appendChild(child);
                }
                else {
                    parentListItem.insertBefore(child, currentList);
                }
            }
        }
        this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, cursorOffset.node, cursorOffset.offset);
    };
    Lists.prototype.findPreviousElementForCursor = function (currentElement) {
        var previousNode = null;
        // Try to find a previous sibling first
        if (currentElement.previousElementSibling) {
            previousNode = currentElement.previousElementSibling;
        }
        // If no previous sibling, try the parent (if not the editable element itself)
        else if (currentElement.parentElement && currentElement.parentElement !== this.parent.editableElement) {
            previousNode = currentElement.parentElement;
        }
        return previousNode;
    };
    Lists.prototype.handleCursorPositioningAfterListRemoval = function (previousNode) {
        if (!previousNode) {
            return;
        }
        // For Safari, explicitly set the cursor position
        if (this.parent.userAgentData.isSafari()) {
            var cursorPosition = this.parent.nodeSelection.findLastTextPosition(previousNode);
            if (cursorPosition) {
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, cursorPosition.node, cursorPosition.offset);
            }
            else {
                // If we can't find a text position, place at the end of the element
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, previousNode, previousNode.childNodes.length);
            }
        }
    };
    Lists.prototype.removeList = function (range, e) {
        var _this = this;
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        var endNode = (!isNOU(range.endContainer.parentElement.closest('li')) && range.endContainer.parentElement.closest('li').childElementCount > 1 && range.endContainer.nodeName === '#text') ? range.endContainer : this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        var parentList = (range.startContainer.nodeName === '#text') ? range.startContainer.parentElement.closest('li') : range.startContainer.closest('li');
        var endParentList = (range.endContainer.nodeName === '#text') ? range.endContainer.parentElement.closest('li') : range.endContainer.closest('li');
        var fullContent = '';
        if (!isNOU(parentList) && !isNOU(parentList.firstChild)) {
            parentList.childNodes.forEach(function (e) {
                fullContent = fullContent + e.textContent;
            });
        }
        startNode = startNode.nodeName === 'BR' ? startNode.parentElement : startNode;
        endNode = endNode.nodeName === 'BR' ? endNode.parentElement : endNode;
        startNode = startNode.nodeName !== 'LI' && !isNOU(startNode.closest('LI')) ? startNode.closest('LI') : startNode;
        endNode = endNode.nodeName !== 'LI' && endNode.nodeName !== '#text' && !isNOU(endNode.closest('LI')) ? endNode.closest('LI') : endNode;
        var endNodeNextElementSibling = (!isNOU(endParentList) && isNOU(endParentList.nextElementSibling));
        if (((range.commonAncestorContainer.nodeName === 'OL' || range.commonAncestorContainer.nodeName === 'UL' || range.commonAncestorContainer.nodeName === 'LI') &&
            isNOU(endNode.nextElementSibling) && endNode.textContent.length === range.endOffset && endNodeNextElementSibling &&
            isNOU(startNode.previousElementSibling) && range.startOffset === 0) ||
            (Browser.userAgent.indexOf('Firefox') !== -1 && range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement &&
                range.startOffset === 0 && range.endOffset === 1)) {
            // Find where to place the cursor before removing elements for safari
            var previousNode_1;
            if (Browser.userAgent.indexOf('Firefox') !== -1) {
                previousNode_1 = this.findPreviousElementForCursor(range.commonAncestorContainer.childNodes[0]);
                detach(range.commonAncestorContainer.childNodes[0]);
            }
            else if (range.commonAncestorContainer.nodeName === 'LI') {
                previousNode_1 = this.findPreviousElementForCursor(range.commonAncestorContainer.parentElement);
                detach(range.commonAncestorContainer.parentElement);
            }
            else {
                previousNode_1 = this.findPreviousElementForCursor(range.commonAncestorContainer);
                detach(range.commonAncestorContainer);
            }
            e.event.preventDefault();
            // Handle cursor positioning for safari
            this.handleCursorPositioningAfterListRemoval(previousNode_1);
            parentList = (range.startContainer.nodeName === '#text') ? range.startContainer.parentElement.closest('li') : range.startContainer.closest('li');
        }
        var previousNode;
        if ((!isNOU(endParentList) && range.commonAncestorContainer === this.parent.editableElement) || (!isNOU(parentList) && (!range.collapsed || (parentList.textContent.trim() === '' && isNOU(parentList.previousElementSibling) && isNOU(parentList.nextElementSibling))) && parentList.textContent === fullContent)) {
            range.deleteContents();
            var listItems_1 = this.parent.editableElement.querySelectorAll('li');
            var _loop_1 = function (i) {
                if (!isNOU(listItems_1[i].childNodes)) {
                    listItems_1[i].childNodes.forEach(function (child) {
                        if (child.nodeName === 'A' && child.textContent === '') {
                            listItems_1[i].removeChild(child);
                        }
                    });
                }
                if ((!listItems_1[i].firstChild || listItems_1[i].textContent.trim() === '' && !this_1.hasMediaElement(listItems_1[i])) && (listItems_1[i] === startNode || listItems_1[i] === endNode || listItems_1[i] === endParentList)) {
                    previousNode = this_1.findPreviousElementForCursor(listItems_1[i]);
                    listItems_1[i].parentNode.removeChild(listItems_1[i]);
                }
            };
            var this_1 = this;
            for (var i = 0; i < listItems_1.length; i++) {
                _loop_1(i);
            }
            this.parent.editableElement.querySelectorAll('ol').forEach(function (ol) {
                if (!ol.firstChild || ol.textContent.trim() === '' && !_this.hasMediaElement(ol)) {
                    previousNode = _this.findPreviousElementForCursor(ol);
                    ol.parentNode.removeChild(ol);
                }
            });
            this.parent.editableElement.querySelectorAll('ul').forEach(function (ul) {
                if (!ul.firstChild || ul.textContent.trim() === '' && !_this.hasMediaElement(ul)) {
                    previousNode = _this.findPreviousElementForCursor(ul);
                    ul.parentNode.removeChild(ul);
                }
            });
            e.event.preventDefault();
            // Handle cursor positioning for safari
            this.handleCursorPositioningAfterListRemoval(previousNode);
        }
    };
    Lists.prototype.onKeyUp = function (e) {
        if (!isNOU(this.commonLIParent) && !isNOU(this.commonLIParent.querySelector('.removeList'))) {
            var currentLIElem = this.commonLIParent.querySelector('.removeList');
            while (!isNOU(currentLIElem.firstChild)) {
                this.parent.domNode.insertAfter(currentLIElem.firstChild, currentLIElem);
            }
            detach(currentLIElem);
        }
        if (e.event.keyCode === 13) {
            var listElements = this.parent.editableElement.querySelectorAll('UL, OL');
            for (var i = 0; i < listElements.length; i++) {
                if (!isNullOrUndefined(listElements[i]) && !isNOU(listElements[i].parentElement) && !isNullOrUndefined(listElements[i].previousElementSibling) && (listElements[i].parentElement.nodeName === 'UL' || listElements[i].parentElement.nodeName === 'OL')) {
                    listElements[i].previousElementSibling.appendChild(listElements[i]);
                }
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Lists.prototype.firstListBackSpace = function (range, _e) {
        var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        var listItem = startNode.closest('LI');
        if (!isNOU(listItem) && !this.isAtListStart(listItem, range)) {
            return;
        }
        if (!isNOU(startNode.closest('OL'))) {
            this.commonLIParent = startNode.closest('OL');
        }
        else if (!isNOU(startNode.closest('UL'))) {
            this.commonLIParent = startNode.closest('UL');
        }
        if (!isNOU(listItem) && range.startOffset === 0 && range.endOffset === 0 &&
            isNOU(startNode.previousSibling) && !isNOU(this.commonLIParent) && isNOU(this.commonLIParent.previousSibling) &&
            (isNOU(this.commonLIParent.parentElement.closest('OL')) && isNOU(this.commonLIParent.parentElement.closest('UL')) &&
                isNOU(this.commonLIParent.parentElement.closest('LI')))) {
            var currentElem = createElement('P');
            currentElem.innerHTML = '&#8203;';
            startNode.classList.add('removeList');
            this.commonLIParent.parentElement.insertBefore(currentElem, this.commonLIParent);
        }
    };
    Lists.prototype.isAtListStart = function (startNode, range) {
        if (startNode.nodeName !== 'LI') {
            return false;
        }
        var listItem = startNode;
        var firstTextNode = this.getFirstTextNode(listItem);
        return firstTextNode === range.startContainer && range.startOffset === 0;
    };
    Lists.prototype.getFirstTextNode = function (element) {
        if (element.nodeType === Node.TEXT_NODE) {
            return element;
        }
        if (element.nodeName === 'BR') {
            return element;
        }
        for (var i = 0; i < element.childNodes.length; i++) {
            var firstTextNode = this.getFirstTextNode(element.childNodes[i]);
            if (firstTextNode) {
                return firstTextNode;
            }
        }
        return null;
    };
    Lists.prototype.keyDownHandler = function (e) {
        if (e.event.which === 13) {
            this.enterList(e);
        }
        if (e.event.which === 32) {
            this.spaceList(e);
        }
        if (e.event.which === 8) {
            this.backspaceList(e);
        }
        if ((e.event.which === 46 && e.event.action === 'delete')) {
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            var commonAncestor = range.commonAncestorContainer;
            var startEle = range.startContainer;
            var endEle = range.endContainer;
            var startNode = startEle.nodeType === 3 ? this.domNode.blockParentNode(startEle) : startEle;
            var endNode = endEle.nodeType === 3 ? this.domNode.blockParentNode(endEle) : endEle;
            if ((commonAncestor.nodeName === 'UL' || commonAncestor.nodeName === 'OL') && startNode !== endNode
                && (!isNullOrUndefined(closest(startNode, 'ul')) || !isNullOrUndefined(closest(startNode, 'ol')))
                && (!isNullOrUndefined(closest(endNode, 'ul')) || !isNullOrUndefined(closest(endNode, 'ol')))
                && ((commonAncestor.lastElementChild === closest(endNode, 'li') && commonAncestor.lastChild !== endNode)) && !range.collapsed) {
                if (this.areAllListItemsSelected(commonAncestor, range)) {
                    detach(commonAncestor);
                }
            }
            this.removeList(range, e);
        }
        if (e.event.which === 9) {
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            if (!(e.event.action && e.event.action === 'indent')) {
                this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            }
            if (e.enableTabKey) {
                this.handleListIndentation(e);
            }
            var blockNodes = void 0;
            var startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
            var endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
            if ((startNode === endNode && (startNode.nodeName === 'BR' || startNode.nodeName === '#text') &&
                CONSTANT.IGNORE_BLOCK_TAGS.indexOf(startNode.parentNode.tagName.toLocaleLowerCase()) >= 0)) {
                return;
            }
            else {
                if (!(e.event.action && (e.event.action === 'indent')) && !this.listTabIndentation) {
                    this.domNode.setMarker(this.saveSelection);
                }
                blockNodes = this.domNode.blockNodes();
            }
            var nodes = [];
            var isNested = true;
            for (var i = 0; i < blockNodes.length; i++) {
                if (blockNodes[i].parentNode.tagName === 'LI') {
                    nodes.push(blockNodes[i].parentNode);
                }
                else if (!closest(blockNodes[i], 'OL') && !closest(blockNodes[i], 'UL') && closest(blockNodes[i], 'LI')) {
                    nodes.push(closest(blockNodes[i], 'LI'));
                }
                else if (blockNodes[i].tagName === 'LI' && blockNodes[i].childNodes[0].tagName !== 'P' &&
                    (blockNodes[i].childNodes[0].tagName !== 'OL' &&
                        blockNodes[i].childNodes[0].tagName !== 'UL')) {
                    nodes.push(blockNodes[i]);
                }
            }
            if (nodes.length > 1 || nodes.length === 1) {
                e.event.preventDefault();
                e.event.stopPropagation();
                this.currentAction = this.getAction(nodes[0]);
                if (e.event.shiftKey && (!e.enableTabKey || (e.enableTabKey && !this.listTabIndentation))) {
                    this.revertList(nodes, e);
                    this.revertClean();
                }
                else if (!e.enableTabKey || (e.enableTabKey && !this.listTabIndentation)) {
                    if (this.indentTab(e)) {
                        isNested = this.nestedList(nodes);
                    }
                }
                if (isNested) {
                    this.cleanNode();
                    this.parent.editableElement.focus({ preventScroll: true });
                }
                if (!(e.event.action && (e.event.action === 'indent')) && !this.listTabIndentation) {
                    this.saveSelection = this.domNode.saveMarker(this.saveSelection);
                    this.saveSelection.restore();
                    if (e.callBack) {
                        e.callBack({
                            requestType: this.currentAction,
                            editorMode: 'HTML',
                            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                            elements: this.parent.domNode.blockNodes(),
                            event: e.event
                        });
                    }
                }
            }
            else {
                if (!(e.event.action && (e.event.action === 'indent')) && !this.listTabIndentation) {
                    if (e.event && e.event.shiftKey && e.event.key === 'Tab') {
                        e.event.action = 'tab';
                    }
                    this.saveSelection = this.domNode.saveMarker(this.saveSelection);
                    this.saveSelection.restore();
                }
            }
            this.listTabIndentation = false;
        }
        else {
            switch (e.event.action) {
                case 'ordered-list':
                    this.applyListsHandler({ subCommand: 'OL', callBack: e.callBack });
                    e.event.preventDefault();
                    break;
                case 'unordered-list':
                    this.applyListsHandler({ subCommand: 'UL', callBack: e.callBack });
                    e.event.preventDefault();
                    break;
                case 'checklist':
                    this.applyListsHandler({ subCommand: 'Checklist', callBack: e.callBack });
                    e.event.preventDefault();
                    break;
            }
        }
    };
    Lists.prototype.handleListIndentation = function (e) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var parentNodeList = this.saveSelection.getParentNodeCollection(range);
        if (!this.indentTab(e)) {
            return;
        }
        if ((parentNodeList[0].nodeName === 'LI' || closest(parentNodeList[0], 'li'))
            && !this.isCursorAtStartOfLI(range)) {
            var startParentNode = parentNodeList[parentNodeList.length - 1];
            var endParentNode = parentNodeList[0];
            var startElementTextNode = range.startContainer;
            if (startParentNode && endParentNode) {
                range.deleteContents();
                if (startParentNode !== endParentNode) {
                    var currentBlockNode = startElementTextNode;
                    while (currentBlockNode.parentElement) {
                        if (this.parent.domNode.isBlockNode(currentBlockNode.parentElement)) {
                            currentBlockNode = currentBlockNode.parentElement;
                            break;
                        }
                        currentBlockNode = currentBlockNode.parentElement;
                    }
                    var cursorPosition = void 0;
                    var tabSpaceHTML = '&nbsp;&nbsp;&nbsp;&nbsp;<span class="rte-tab-space"></span>';
                    if (this.parent.domNode.isBlockNode(startParentNode.lastChild)) {
                        startElementTextNode.nodeValue += '\u00A0\u00A0\u00A0\u00A0';
                        cursorPosition = startElementTextNode.nodeValue.length;
                    }
                    else {
                        startParentNode.innerHTML += tabSpaceHTML;
                    }
                    var listItemFirstChild = endParentNode.firstChild;
                    if (listItemFirstChild && this.parent.domNode.isBlockNode(listItemFirstChild)) {
                        while (listItemFirstChild.firstChild) {
                            currentBlockNode.appendChild(listItemFirstChild.firstChild);
                        }
                        listItemFirstChild.remove();
                    }
                    while (endParentNode.firstChild) {
                        if (this.parent.domNode.isBlockNode(endParentNode.firstChild)) {
                            this.parent.domNode.insertAfter(endParentNode.firstChild, currentBlockNode);
                        }
                        else {
                            startParentNode.appendChild(endParentNode.firstChild);
                        }
                    }
                    endParentNode.remove();
                    var tabSpanElement = startParentNode.querySelector('.rte-tab-space');
                    if (tabSpanElement && tabSpanElement.previousSibling) {
                        this.saveSelection.setCursorPoint(this.parent.currentDocument, tabSpanElement.previousSibling, tabSpanElement.previousSibling.textContent.length);
                        tabSpanElement.parentNode.removeChild(tabSpanElement);
                    }
                    else {
                        this.saveSelection.setCursorPoint(this.parent.currentDocument, startElementTextNode, cursorPosition);
                    }
                }
                else {
                    InsertHtml.Insert(this.parent.currentDocument, '&nbsp;&nbsp;&nbsp;&nbsp;', this.parent.editableElement);
                }
                this.listTabIndentation = true;
            }
        }
    };
    /**
     * Checks if inserting a tab would exceed the maxLength constraint.
     *
     * @param {IHtmlKeyboardEvent} e - The keyboard event containing the maxLength constraint
     * @returns {boolean} True if allowed, false if it would exceed maxLength.
     */
    Lists.prototype.indentTab = function (e) {
        var tabSpaceLength = 4;
        var maxLength = (typeof e.maxLength === 'number') ? e.maxLength : -1;
        var currentLength = this.parent.editableElement.textContent
            .replace(/(\r\n|\n|\r|\t)/gm, '')
            .replace(/\u200B/g, '').length;
        var selectionLength = this.parent.currentDocument.getSelection().toString().length;
        return maxLength === -1 || (currentLength - selectionLength + tabSpaceLength) <= maxLength;
    };
    Lists.prototype.isCursorAtStartOfLI = function (range) {
        var node = range.startContainer;
        while (node && node.nodeName !== 'LI') {
            node = node.parentNode;
        }
        if (!node) {
            return false;
        }
        var tempRange = range.cloneRange();
        tempRange.selectNodeContents(node);
        tempRange.setEnd(range.startContainer, range.startOffset);
        return tempRange.toString().trim() === '';
    };
    Lists.prototype.spaceKeyAction = function (e) {
        if (e.event.which === 32) {
            this.spaceList(e);
        }
    };
    Lists.prototype.getAction = function (element) {
        var parentNode = element.parentNode;
        return (parentNode.nodeName === 'OL' ? 'OL' : 'UL');
    };
    Lists.prototype.revertClean = function () {
        var collectionNodes = this.parent.editableElement.querySelectorAll('ul, ol');
        for (var i = 0; i < collectionNodes.length; i++) {
            var listNodes = collectionNodes[i].querySelectorAll('ul, ol');
            if (listNodes.length > 0) {
                for (var j = 0; j < listNodes.length; j++) {
                    var prevSibling = listNodes[j].previousSibling;
                    if (prevSibling && prevSibling.tagName === 'LI') {
                        prevSibling.appendChild(listNodes[j]);
                    }
                }
            }
        }
    };
    Lists.prototype.noPreviousElement = function (elements) {
        var firstNode;
        var firstNodeOL;
        var siblingListOL = elements.querySelectorAll('ol, ul');
        var siblingListLI = elements
            .querySelectorAll('li');
        var siblingListLIFirst = this.domNode.contents(siblingListLI[0])[0];
        if (siblingListLI.length > 0 && (siblingListOL.length <= 1 || siblingListOL[0].childNodes.length > 1) && (siblingListLIFirst.nodeName === 'OL' || siblingListLIFirst.nodeName === 'UL')) {
            firstNode = siblingListLI[0];
        }
        else {
            firstNodeOL = siblingListOL[0];
        }
        if (firstNode) {
            for (var h = this.domNode.contents(elements)[0]; h && !this.domNode.isList(h); null) {
                var nextSibling = h.nextSibling;
                prepend([h], firstNode);
                setStyleAttribute(elements, { 'list-style-type': 'none' });
                var listHasCheckListClass = elements.parentNode && elements.parentNode.classList.contains('e-rte-checklist');
                if (listHasCheckListClass) {
                    addClass([elements], ['e-rte-checklist-hidden']);
                }
                setStyleAttribute(firstNode, { 'list-style-type': '' });
                h = nextSibling;
            }
        }
        else if (firstNodeOL) {
            var nestedElement = createElement('li');
            prepend([nestedElement], firstNodeOL);
            for (var h = this.domNode.contents(elements)[0]; h && !this.domNode.isList(h); null) {
                var nextSibling = h.nextSibling;
                nestedElement.appendChild(h);
                h = nextSibling;
            }
            var listHasCheckListClass = elements.parentNode && elements.parentNode.classList.contains('e-rte-checklist');
            prepend([firstNodeOL], elements.parentNode);
            detach(elements);
            var nestedElementLI = createElement('li', { styles: 'list-style-type: none;' });
            if (listHasCheckListClass) {
                addClass([nestedElementLI], ['e-rte-checklist-hidden']);
            }
            prepend([nestedElementLI], firstNodeOL.parentNode);
            append([firstNodeOL], nestedElementLI);
        }
        else {
            var nestedElementLI = createElement('li', { styles: 'list-style-type: none;' });
            prepend([nestedElementLI], elements.parentNode);
            var nestedElement = createElement(elements.parentNode.tagName);
            if (elements.parentNode.classList.contains('e-rte-checklist')) {
                addClass([nestedElement], ['e-rte-checklist']);
                addClass([nestedElementLI], ['e-rte-checklist-hidden']);
            }
            prepend([nestedElement], nestedElementLI);
            append([elements], nestedElement);
        }
    };
    Lists.prototype.nestedList = function (elements) {
        var isNested = false;
        var _loop_2 = function (i) {
            var prevSibling = this_2.domNode.getPreviousNode(elements[i]);
            if (prevSibling) {
                isNested = true;
                var firstNode = void 0;
                var firstNodeLI = void 0;
                var siblingListOL = elements[i].querySelectorAll('ol, ul');
                var siblingListLI = elements[i]
                    .querySelectorAll('li');
                var siblingListLIFirst = this_2.domNode.contents(siblingListLI[0])[0];
                if (siblingListLI.length > 0 && (siblingListOL.length <= 1 || siblingListOL[0].childNodes.length > 1) && (siblingListLIFirst.nodeName === 'OL' || siblingListLIFirst.nodeName === 'UL')) {
                    firstNodeLI = siblingListLI[0];
                }
                else {
                    firstNode = siblingListOL[0];
                }
                if (firstNode) {
                    var nestedElement = createElement('li');
                    prepend([nestedElement], firstNode);
                    for (var h = this_2.domNode.contents(elements[i])[0]; h && !this_2.domNode.isList(h); null) {
                        var nextSibling = h.nextSibling;
                        nestedElement.appendChild(h);
                        h = nextSibling;
                    }
                    if (prevSibling.parentNode && prevSibling.parentNode.classList.contains('e-rte-checklist')) {
                        addClass([firstNode], ['e-rte-checklist']);
                    }
                    append([firstNode], prevSibling);
                    detach(elements[i]);
                }
                else if (firstNodeLI) {
                    if (prevSibling.tagName === 'LI') {
                        for (var h = this_2.domNode.contents(elements[i])[0]; h && !this_2.domNode.isList(h); null) {
                            var nextSibling = h.nextSibling;
                            prepend([h], firstNodeLI);
                            setStyleAttribute(elements[i], { 'list-style-type': 'none' });
                            setStyleAttribute(firstNodeLI, { 'list-style-type': '' });
                            h = nextSibling;
                        }
                        append([firstNodeLI.parentNode], prevSibling);
                        detach(elements[i]);
                    }
                }
                else {
                    if (prevSibling.tagName === 'LI') {
                        var nestedElement = createElement(elements[i].parentNode.tagName);
                        if (elements[i].parentNode.classList.contains('e-rte-checklist')) {
                            addClass([nestedElement], ['e-rte-checklist']);
                        }
                        nestedElement.style.listStyleType =
                            elements[i].parentNode.style.listStyleType;
                        // Compare inline styles of prevSibling with computed styles of current element
                        var prevInlineStyle = prevSibling.getAttribute('style');
                        var computedStyles_1 = getComputedStyle(elements[i]);
                        var currentInlineStyle_1 = elements[i].style;
                        if (prevInlineStyle) {
                            var stylePairs = prevInlineStyle.split(';').filter(Boolean);
                            stylePairs.forEach(function (style) {
                                var _a = style.split(':').map(function (s) { return s.trim(); }), prop = _a[0], value = _a[1];
                                if (prop && value && prop !== 'list-style-type') {
                                    var computedValue = computedStyles_1.getPropertyValue(prop).trim();
                                    var currentInlineValue = currentInlineStyle_1.getPropertyValue(prop).trim();
                                    if (computedValue !== value && !currentInlineValue) {
                                        // Set the inline style to match the computed style
                                        elements[i].style.setProperty(prop, computedValue);
                                    }
                                }
                            });
                        }
                        append([nestedElement], prevSibling);
                        append([elements[i]], nestedElement);
                    }
                    else if (prevSibling.tagName === 'OL' || prevSibling.tagName === 'UL') {
                        append([elements[i]], prevSibling);
                    }
                }
            }
            else {
                var element = elements[i];
                isNested = true;
                this_2.noPreviousElement(element);
            }
        };
        var this_2 = this;
        for (var i = 0; i < elements.length; i++) {
            _loop_2(i);
        }
        return isNested;
    };
    Lists.prototype.isCursorBeforeTable = function (range) {
        return range.startOffset === range.endOffset &&
            range.startContainer.childNodes.length > 0 && !isNOU(range.startContainer.childNodes[range.startOffset]) &&
            range.startContainer.childNodes[range.startOffset].nodeName === 'TABLE';
    };
    Lists.prototype.isCursorAtEndOfTable = function (range) {
        return (range.startOffset === range.endOffset &&
            range.startContainer.childNodes.length > 0 && !isNOU(range.startContainer.childNodes[range.startOffset - 1]) &&
            range.startContainer.childNodes[range.startOffset - 1].nodeName === 'TABLE');
    };
    Lists.prototype.isListItemWithTableChild = function (node) {
        return node.nodeName === 'LI' && !isNOU(node.firstChild) &&
            node.firstChild.nodeName === 'TABLE';
    };
    Lists.prototype.handleChecklistToggle = function (e) {
        var target = e.event.target;
        if (target.tagName === 'LI' || !isNullOrUndefined(closest(target, '.' + 'e-rte-checklist'))) {
            e.event.preventDefault();
            e.event.stopPropagation();
            if (target.classList.contains('e-rte-checklist-checked')) {
                target.classList.remove('e-rte-checklist-checked');
            }
            else {
                target.classList.add('e-rte-checklist-checked');
            }
        }
    };
    Lists.prototype.isCaretImmediatelyBeforeTable = function (range) {
        var cursorBeforeTable = false;
        var table = null;
        var isBeforeFirstTable = range.collapsed && range.startContainer === range.endContainer &&
            range.startOffset === range.endOffset &&
            range.startContainer.nodeType === Node.ELEMENT_NODE &&
            range.startContainer.childNodes[range.startOffset] && range.startContainer.childNodes[range.startOffset].nodeName === 'TABLE';
        if (isBeforeFirstTable) {
            table = range.startContainer.childNodes[range.startOffset];
            var newRange = this.parent.editableElement.ownerDocument.createRange();
            newRange.setStartBefore(table);
            newRange.setEndBefore(table);
            cursorBeforeTable = range.startContainer === newRange.startContainer &&
                range.endContainer === newRange.endContainer &&
                range.startOffset === newRange.startOffset &&
                range.endOffset === newRange.endOffset;
        }
        if (cursorBeforeTable && !isNOU(table)) {
            table.classList.add('temp-cursor-table');
            return true;
        }
        return false;
    };
    Lists.prototype.applyListsHandler = function (e, isCheckedCheckList) {
        var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        var isRangeBeforeTable = this.isCaretImmediatelyBeforeTable(range);
        var checkListToggleAction = e.subCommand === 'Checklist' && e.item && e.item.action === 'toggleChecklist';
        if (checkListToggleAction) {
            this.handleChecklistToggle(e);
        }
        else {
            var selectedNode = (range.startContainer.nodeName === 'HR' ? range.startContainer : range.startContainer.childNodes[range.startOffset]);
            var lastSelectedNode = (selectedNode ? (selectedNode.nodeName === 'HR' ? selectedNode.nextElementSibling : null) : null);
            var checkCursorPointer = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if (Browser.userAgent.indexOf('Firefox') !== -1 && range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement) {
                var startChildNodes = range.startContainer.childNodes;
                var startNode = ((startChildNodes[(range.startOffset > 0) ? (range.startOffset - 1) :
                    range.startOffset]) || range.startContainer);
                var endNode = (range.endContainer.childNodes[(range.endOffset > 0) ? (range.endOffset - 1) :
                    range.endOffset] || range.endContainer);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var lastSelectionNode = endNode.lastChild.nodeName === 'BR' ? (isNOU(endNode.lastChild.previousSibling) ? endNode
                    : endNode.lastChild.previousSibling) : endNode.lastChild;
                while (!isNOU(lastSelectionNode) && lastSelectionNode.nodeName !== '#text' && lastSelectionNode.nodeName !== 'IMG' &&
                    lastSelectionNode.nodeName !== 'BR' && lastSelectionNode.nodeName !== 'HR') {
                    lastSelectionNode = lastSelectionNode.lastChild;
                }
                this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startNode, lastSelectionNode, 0, lastSelectionNode.textContent.length);
                range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            }
            if (range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement &&
                range.startOffset === range.endOffset && range.startOffset === 0 &&
                this.parent.editableElement.textContent.length === 0 && (this.parent.editableElement.childNodes[0].nodeName !== 'TABLE' &&
                this.parent.editableElement.childNodes[0].nodeName !== 'IMG')) {
                var focusNode = range.startContainer.childNodes[0];
                this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, focusNode, focusNode, 0, 0);
                range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            }
            this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            this.currentAction = e.subCommand;
            this.currentAction = e.subCommand = this.currentAction === 'NumberFormatList' ? 'OL' : this.currentAction === 'BulletFormatList' ? 'UL' : this.currentAction;
            this.domNode.setMarker(this.saveSelection);
            var listsNodes = this.domNode.blockNodes(true);
            if (e.enterAction === 'BR') {
                if (this.isCursorBeforeTable(range)) {
                    listsNodes = [range.startContainer.childNodes[range.startOffset]];
                }
                else if (this.isCursorAtEndOfTable(range)) {
                    listsNodes = [range.startContainer.childNodes[range.startOffset - 1]];
                }
                else if (listsNodes.length === 1 && this.isListItemWithTableChild(listsNodes[0])) {
                    listsNodes[0] = listsNodes[0].firstChild;
                }
                else {
                    this.setSelectionBRConfig();
                    this.parent.domNode.convertToBlockNodes(this.parent.domNode.blockNodes(), true);
                    this.setSelectionBRConfig();
                    listsNodes = this.parent.domNode.blockNodes();
                }
            }
            for (var i = 0; i < listsNodes.length; i++) {
                if (listsNodes[i].tagName === 'TABLE' && !range.collapsed) {
                    listsNodes.splice(i, 1);
                }
                if (listsNodes.length > 0 && listsNodes[i].tagName !== 'LI'
                    && 'LI' === listsNodes[i].parentNode.tagName) {
                    listsNodes[i] = listsNodes[i].parentNode;
                }
            }
            this.applyLists(listsNodes, this.currentAction, e.selector, e.item, e, checkCursorPointer, isCheckedCheckList);
            if (lastSelectedNode && range.startContainer === range.endContainer && range.startOffset === range.endOffset) {
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, lastSelectedNode, 0);
            }
            if (isRangeBeforeTable) {
                var table = this.parent.editableElement.ownerDocument.querySelector('.temp-cursor-table');
                if (!isNullOrUndefined(table)) {
                    var newRange = this.parent.editableElement.ownerDocument.createRange();
                    newRange.setStartBefore(table);
                    newRange.setEndBefore(table);
                    this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
                    removeClass([table], ['temp-cursor-table']);
                }
            }
        }
        if (e.callBack) {
            e.callBack({
                requestType: this.currentAction,
                event: e.event,
                editorMode: 'HTML',
                range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                elements: this.parent.domNode.blockNodes()
            });
        }
    };
    Lists.prototype.setSelectionBRConfig = function () {
        var startElem = this.parent.editableElement.querySelector('.' + markerClassName.startSelection);
        var endElem = this.parent.editableElement.querySelector('.' + markerClassName.endSelection);
        if (isNOU(endElem)) {
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, startElem, 0);
        }
        else {
            this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startElem, endElem, 0, 0);
        }
    };
    // This method identifies unique list items and their top-level UL/OL parents from a given set of elements, returning both in separate arrays.
    Lists.prototype.commonRevertList = function (elements) {
        var commonList = [];
        var commonListParent = [];
        var commonElement;
        for (var i = 0; i < elements.length; i++) {
            var commonParentULorOL = elements[i].parentElement;
            while (this.isListTag(commonParentULorOL.parentElement.nodeName)) {
                commonParentULorOL = commonParentULorOL.parentElement;
            }
            if (i === 0) {
                commonList.push(elements[i]);
                commonElement = commonParentULorOL;
                commonListParent.push(commonElement);
                continue;
            }
            if (commonParentULorOL !== commonElement) {
                commonList.push(elements[i]);
                commonElement = commonParentULorOL;
                commonListParent.push(commonElement);
            }
        }
        return { commonList: commonList, commonListParent: commonListParent };
    };
    Lists.prototype.applyLists = function (elements, type, selector, item, e, checkCursorPointer, isCheckedCheckList) {
        var isReverse = true;
        if (type === 'Checklist') {
            type = 'UL';
        }
        if (this.isRevert(elements, type, item, e.subCommand) && isNOU(item)) {
            var revertListELements = this.commonRevertList(elements);
            this.completeRevertList(revertListELements, e.enterAction);
        }
        else {
            this.checkLists(elements, type, item, checkCursorPointer, e.subCommand, isCheckedCheckList);
            var targetEl = elements[0];
            var marginLeftAttribute = [];
            if (targetEl.style.marginLeft !== '') {
                marginLeftAttribute.push({ 'margin-left': targetEl.style.marginLeft });
            }
            var listStyles = [];
            for (var i = 0; i < elements.length; i++) {
                if (!isNOU(item) && !isNOU(item.listStyle) && e.subCommand !== 'Checklist') {
                    if (item.listStyle === 'listImage') {
                        listStyles.push({ 'list-style-image': item.listImage });
                    }
                    else {
                        var formattedStyle = this.formatListStyle(item.listStyle);
                        listStyles.push({
                            'list-style-image': 'none',
                            'list-style-type': formattedStyle
                        });
                    }
                }
                elements[i].style.removeProperty('margin-left');
                var elemAtt = elements[i].tagName === 'IMG' || elements[i].classList.contains('e-editor-select-start') || elements[i].tagName === 'TABLE' ? {} : this.extractAllAttributes(elements[i]);
                if (elements[i].getAttribute('contenteditable') === 'true'
                    && elements[i].childNodes.length === 1 && elements[i].childNodes[0].nodeName === 'TABLE') {
                    var listEle = document.createElement(type);
                    listEle.innerHTML = '<li><br/></li>';
                    elements[i].appendChild(listEle);
                }
                else if ('LI' !== elements[i].tagName && isNOU(item) &&
                    elements[i].nodeName === 'BLOCKQUOTE') {
                    isReverse = false;
                    var tempElement = this.parent.editableElement.ownerDocument.createElement('div');
                    var ul = this.parent.editableElement.ownerDocument.createElement(type);
                    this.applyListStyles(ul, marginLeftAttribute);
                    this.applyListStyles(ul, listStyles);
                    var replaceHTML = elements[i].innerHTML;
                    var li = this.parent.editableElement.ownerDocument.createElement('li');
                    this.applyAllAttributes(li, elemAtt);
                    if (isCheckedCheckList) {
                        li.classList.add('e-rte-checklist-checked');
                    }
                    li.innerHTML = replaceHTML;
                    ul.appendChild(li);
                    tempElement.appendChild(ul);
                    var collectionString = tempElement.innerHTML;
                    if (e.subCommand === 'Checklist') {
                        collectionString = this.addCheckListClass(collectionString);
                    }
                    elements[i].innerHTML = collectionString;
                }
                else if ('LI' !== elements[i].tagName && isNOU(item)) {
                    isReverse = false;
                    // const tempElement: HTMLElement = this.parent.editableElement.ownerDocument.createElement('div');
                    var ul = this.parent.editableElement.ownerDocument.createElement(type);
                    this.applyListStyles(ul, marginLeftAttribute);
                    this.applyListStyles(ul, listStyles);
                    var replaceHTML = void 0;
                    if (elements[i].tagName.toLowerCase() === CONSTANT.DEFAULT_TAG || elements[i].tagName === 'DIV') {
                        replaceHTML = elements[i].innerHTML;
                    }
                    else {
                        replaceHTML = elements[i].outerHTML;
                    }
                    if (elements[i].tagName === 'HR' &&
                        elements[i].firstElementChild &&
                        elements[i].firstElementChild.tagName === 'SPAN' &&
                        elements[i].firstElementChild.hasAttribute('class') &&
                        elements[i].firstElementChild.className === 'e-editor-select-start') {
                        replaceHTML = elements[i].firstElementChild.outerHTML + elements[i].outerHTML;
                    }
                    var li = this.parent.editableElement.ownerDocument.createElement('li');
                    this.applyAllAttributes(li, elemAtt);
                    if (isCheckedCheckList) {
                        li.classList.add('e-rte-checklist-checked');
                    }
                    li.innerHTML = replaceHTML;
                    var innerHTML = li.outerHTML;
                    innerHTML = this.setStyle(innerHTML);
                    ul.innerHTML = innerHTML;
                    var collectionString = ul.outerHTML;
                    if (e.subCommand === 'Checklist') {
                        collectionString = this.addCheckListClass(collectionString);
                    }
                    this.domNode.replaceWith(elements[i], collectionString);
                }
                else if (!isNOU(item) && 'LI' !== elements[i].tagName) {
                    // eslint-disable-next-line
                    isReverse = false;
                    var tempElement = this.parent.editableElement.ownerDocument.createElement('div');
                    var ul = this.parent.editableElement.ownerDocument.createElement(type);
                    this.applyListStyles(ul, listStyles);
                    tempElement.appendChild(ul);
                    var replaceHTML = void 0;
                    if (elements[i].tagName.toLowerCase() === CONSTANT.DEFAULT_TAG || elements[i].tagName === 'DIV') {
                        replaceHTML = elements[i].innerHTML;
                    }
                    else {
                        replaceHTML = elements[i].outerHTML;
                    }
                    var li = this.parent.editableElement.ownerDocument.createElement('li');
                    this.applyAllAttributes(li, elemAtt);
                    if (isCheckedCheckList) {
                        li.classList.add('e-rte-checklist-checked');
                    }
                    li.innerHTML = replaceHTML;
                    var innerHTML = li.outerHTML;
                    ul.innerHTML = innerHTML;
                    var collectionString = tempElement.innerHTML;
                    if (e.subCommand === 'Checklist') {
                        collectionString = this.addCheckListClass(collectionString);
                    }
                    this.domNode.replaceWith(elements[i], collectionString);
                }
            }
        }
        this.cleanNode();
        if (e.enterAction === 'BR') {
            var spansToRemove = document.querySelectorAll('span#removeSpan');
            spansToRemove.forEach(function (span) {
                var fragment = document.createDocumentFragment();
                while (span.firstChild) {
                    fragment.appendChild(span.firstChild);
                }
                span.parentNode.replaceChild(fragment, span);
            });
        }
        this.parent.editableElement.focus({ preventScroll: true });
        if (isIDevice()) {
            setEditFrameFocus(this.parent.editableElement, selector);
        }
        this.saveSelection = this.domNode.saveMarker(this.saveSelection);
        this.saveSelection.restore();
    };
    Lists.prototype.extractAllAttributes = function (element) {
        var attributes = {};
        if (element && element.attributes) {
            Array.from(element.attributes).forEach(function (attr) {
                attributes[attr.name] = attr.value;
            });
        }
        return attributes;
    };
    Lists.prototype.applyAllAttributes = function (element, attributes) {
        Object.keys(attributes).forEach(function (key) {
            element.setAttribute(key, attributes[key]);
        });
    };
    Lists.prototype.applyListStyles = function (element, listStyles) {
        for (var i = 0; i < listStyles.length; i++) {
            var styleObj = listStyles[i];
            for (var key in styleObj) {
                if (Object.prototype.hasOwnProperty.call(styleObj, key)) {
                    element.style.setProperty(key, styleObj[key]);
                }
            }
        }
    };
    Lists.prototype.addCheckListClass = function (collectionString) {
        var divElement = createElement('div');
        divElement.innerHTML = collectionString;
        var checkLists = divElement.firstElementChild;
        this.applyCheckListClasses(checkLists);
        return divElement.innerHTML;
    };
    Lists.prototype.applyCheckListClasses = function (element) {
        addClass([element], 'e-rte-checklist');
    };
    Lists.prototype.setStyle = function (innerHTML) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = innerHTML;
        var liElement = tempDiv.querySelector('li');
        if (!liElement) {
            return innerHTML;
        }
        var targetProps = ['color', 'font-size', 'font-family', 'font-weight', 'font-style'];
        var styleTextMap = new Map(); // Map<styleProp, Map<styleValue, text>>
        var walker = this.parent.currentDocument.createTreeWalker(liElement, NodeFilter.SHOW_TEXT, null);
        var node = walker.nextNode();
        var _loop_3 = function () {
            var text = node.textContent || '';
            var current = node.parentElement;
            var styleSnapshot = new Map();
            // Traverse up to <li> and collect inline styles and semantic tags
            while (current && current !== liElement) {
                targetProps.forEach(function (prop) {
                    var inlineValue = current.style.getPropertyValue(prop);
                    if (inlineValue && !styleSnapshot.has(prop)) {
                        styleSnapshot.set(prop, inlineValue);
                    }
                });
                if ((current.tagName === 'B' || current.tagName === 'STRONG') && !styleSnapshot.has('font-weight')) {
                    styleSnapshot.set('font-weight', 'bold');
                }
                if ((current.tagName === 'I' || current.tagName === 'EM') && !styleSnapshot.has('font-style')) {
                    styleSnapshot.set('font-style', 'italic');
                }
                current = current.parentElement;
            }
            // Merge text into styleTextMap
            styleSnapshot.forEach(function (value, prop) {
                if (!styleTextMap.has(prop)) {
                    styleTextMap.set(prop, new Map());
                }
                var valueMap = styleTextMap.get(prop) || new Map();
                var existingText = valueMap.get(value) || '';
                valueMap.set(value, existingText + text);
            });
            node = walker.nextNode();
        };
        while (node) {
            _loop_3();
        }
        // Apply styles where the accumulated text matches li's full text
        styleTextMap.forEach(function (valueMap, prop) {
            valueMap.forEach(function (text, styleValue) {
                if (text === liElement.textContent) {
                    liElement.style.setProperty(prop, styleValue);
                }
            });
        });
        return tempDiv.innerHTML;
    };
    Lists.prototype.isRevert = function (nodes, tagName, item, subCommand) {
        var isRevert = true;
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].tagName !== 'LI') {
                return false;
            }
            if (nodes[i].parentNode.tagName !== tagName ||
                isNOU(item) && nodes[i].parentNode.style.listStyleType !== '' ||
                (nodes[i].parentNode.tagName === 'UL' && nodes[i].parentNode.classList.contains('e-rte-checklist') && subCommand !== 'Checklist')) {
                isRevert = false;
            }
            if (nodes[i].parentNode.tagName === tagName && nodes[i].parentNode.style.listStyleType !== '') {
                isRevert = true;
            }
            if (nodes[i].parentNode.tagName === 'UL' && !nodes[i].parentNode.classList.contains('e-rte-checklist') && subCommand === 'Checklist') {
                isRevert = false;
            }
        }
        return isRevert;
    };
    Lists.prototype.checkLists = function (nodes, tagName, item, checkCursorPointer, subCommand, isCheckedCheckList) {
        var nodesTemp = [];
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i].parentNode;
            if ((nodes[i].tagName === 'LI' && node.tagName !== tagName && nodesTemp.indexOf(node) < 0) ||
                (nodes[i].tagName === 'LI' && node.tagName === tagName && nodesTemp.indexOf(node) < 0 && item !== null) ||
                (nodes[i].tagName === 'LI' && node.tagName === tagName && subCommand === 'Checklist' && nodesTemp.indexOf(node) < 0) ||
                (nodes[i].tagName === 'LI' && node.tagName === tagName && subCommand !== 'Checklist' && nodesTemp.indexOf(node) < 0 && node.classList.contains('e-rte-checklist'))) {
                nodesTemp.push(node);
            }
            if (isNOU(item) && (node.tagName === tagName ||
                ((node.tagName === 'UL' || node.tagName === 'OL') && node.hasAttribute('style')))) {
                if (node.hasAttribute('style')) {
                    node.removeAttribute('style');
                }
            }
        }
        this.convertListType(nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand, isCheckedCheckList);
    };
    /*
     * Convert list type based on the different list
     * Transforms selected list items between ordered and unordered lists
     */
    Lists.prototype.convertListType = function (nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand, isCheckedCheckList) {
        tagName = subCommand === 'Checklist' ? 'Checklist' : tagName;
        // Add classes to selected LI elements for tracking
        for (var k = 0; k < nodes.length; k++) {
            nodes[k].classList.add('list-temp-element');
            if (isCheckedCheckList) {
                nodes[k].classList.add('e-rte-checklist-checked');
            }
        }
        // First call with reverse order because when elements are changed in the DOM during nested list usecase,
        // the DOM element has already changed and we can no longer get that element in the collection.
        // So the nested use case is not working. That's why we reverse and convert with the normal order.
        // For the reverse order, most of them are converted however some of that not working because of nested list,
        // so once again call the convert with the normal order - that way it works well.
        var reversedParentLists = Array.from(new Set(nodes.map(function (node) { return node.parentNode; })
            .filter(function (parent) { return parent.tagName === 'OL' || parent.tagName === 'UL'; }))).reverse();
        this.convertListTypeInternal(reversedParentLists, nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand);
        // Update nodes reference to point to converted elements in DOM
        nodes = Array.from(this.parent.currentDocument.querySelectorAll('.list-temp-element'));
        // Second call without reverse - process any remaining unconverted elements from first pass
        var naturalOrderParentLists = Array.from(new Set(nodes.map(function (node) { return node.parentNode; })
            .filter(function (parent) { return parent.tagName === 'OL' || parent.tagName === 'UL'; })));
        this.convertListTypeInternal(naturalOrderParentLists, nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand);
        // Update nodes reference again after second conversion
        nodes = Array.from(this.parent.currentDocument.querySelectorAll('.list-temp-element'));
        nodes.forEach(function (el) {
            el.classList.remove('list-temp-element');
            if (el.classList.length === 0) {
                el.removeAttribute('class');
            }
        });
    };
    Lists.prototype.convertListTypeInternal = function (initialNodesTemp, nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand) {
        var _this = this;
        var _loop_4 = function (i) {
            var list = initialNodesTemp[i];
            if (!checkCursorPointer && (list.tagName === 'UL' || list.tagName === 'OL')) {
                var newFragment_1 = this_3.parent.currentDocument.createDocumentFragment();
                var currentTagName_1 = list.tagName;
                // Track if current list is a checklist
                var isCurrentChecklist_1 = list.classList.contains('e-rte-checklist');
                // Determine if target is a checklist
                var isTargetChecklist_1 = tagName === 'Checklist';
                var newList_1 = this_3.parent.currentDocument.createElement(isTargetChecklist_1 ? 'ul' : tagName.toLowerCase());
                // Add class for checklist if target is checklist
                if (isTargetChecklist_1) {
                    this_3.applyCheckListClasses(newList_1);
                }
                var listElements = Array.from(list.children).filter(function (child) { return child.tagName === 'LI'; });
                listElements.forEach(function (child) {
                    if (nodes.indexOf(child) !== -1) {
                        // Check if we're dealing with the same list type
                        if ((currentTagName_1 === (isTargetChecklist_1 ? 'ul' : tagName.toLowerCase())) &&
                            (isCurrentChecklist_1 === isTargetChecklist_1)) {
                            var clonedChild = child.cloneNode(true);
                            if (!isCurrentChecklist_1 && clonedChild.classList.contains('e-rte-checklist-checked')) {
                                clonedChild.classList.remove('e-rte-checklist-checked');
                            }
                            newList_1.appendChild(clonedChild);
                        }
                        else {
                            // Create new list for different type
                            var createNodeName = isTargetChecklist_1 ? 'UL' : tagName;
                            newList_1 = _this.parent.currentDocument.createElement(createNodeName.toLowerCase());
                            if (currentTagName_1 === tagName && !(list.classList.contains('e-rte-checklist') && tagName === 'UL')) {
                                _this.transferAttributes(list, newList_1);
                            }
                            // Add class for checklist if target is checklist
                            if (isTargetChecklist_1) {
                                _this.applyCheckListClasses(newList_1);
                            }
                            currentTagName_1 = isTargetChecklist_1 ? 'ul' : tagName.toLowerCase();
                            // Store the current checklist state BEFORE processing child
                            isCurrentChecklist_1 = isTargetChecklist_1;
                            newFragment_1.appendChild(newList_1);
                            var clonedChild = child.cloneNode(true);
                            _this.applyListItemStyle(newList_1, item);
                            if (!isCurrentChecklist_1 && clonedChild.classList.contains('e-rte-checklist-checked')) {
                                clonedChild.classList.remove('e-rte-checklist-checked');
                            }
                            newList_1.appendChild(clonedChild);
                        }
                    }
                    else {
                        if (currentTagName_1 !== list.tagName.toLowerCase() || isCurrentChecklist_1 !== list.classList.contains('e-rte-checklist')) {
                            currentTagName_1 = list.tagName.toLowerCase();
                            isCurrentChecklist_1 = list.classList.contains('e-rte-checklist');
                            newList_1 = _this.parent.currentDocument.createElement(currentTagName_1);
                            // Add class for checklist if it's a checklist
                            if (isCurrentChecklist_1) {
                                _this.applyCheckListClasses(newList_1);
                            }
                            _this.transferAttributes(list, newList_1);
                            newFragment_1.appendChild(newList_1);
                        }
                        newList_1.appendChild(child.cloneNode(true));
                    }
                });
                list.parentNode.replaceChild(newFragment_1, list);
            }
            else if (checkCursorPointer) {
                for (var j = nodesTemp.length - 1; j >= 0; j--) {
                    var h = nodesTemp[j];
                    var createNodeName = tagName === 'Checklist' ? 'ul' : tagName;
                    var replace = '<' + createNodeName.toLowerCase() + ' '
                        + this_3.domNode.attributes(h) + '>' + h.innerHTML + '</' + createNodeName.toLowerCase() + '>';
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = replace;
                    this_3.applyListItemStyle(tempDiv.firstChild, item);
                    if (subCommand === 'Checklist') {
                        // Add the check list class to the list so we can convert that list into the check list.
                        tempDiv.innerHTML = this_3.addCheckListClass(tempDiv.innerHTML);
                    }
                    else {
                        // Revert the check list element when converting to other type of list
                        var listElement = tempDiv.querySelectorAll('li');
                        for (var k = 0; k < listElement.length; k++) {
                            this_3.revertChecklistItem(listElement[k]);
                        }
                        // If converting a check list to another type of list, remove the check list class from the list.
                        if (tempDiv.firstElementChild && tempDiv.firstElementChild.classList.contains('e-rte-checklist')) {
                            tempDiv.firstElementChild.classList.remove('e-rte-checklist');
                            if (tempDiv.firstElementChild.classList.length === 0) {
                                tempDiv.firstElementChild.removeAttribute('class');
                            }
                        }
                    }
                    this_3.domNode.replaceWith(nodesTemp[j], tempDiv.innerHTML);
                }
            }
        };
        var this_3 = this;
        for (var i = 0; i < initialNodesTemp.length; i++) {
            _loop_4(i);
        }
    };
    /*
     * Applies list style to a list item element
     * @param node The list item element to apply styles to
     * @param item The advanced list item configuration
     */
    Lists.prototype.applyListItemStyle = function (node, item) {
        if (!isNOU(item) && !isNOU(item.listStyle)) {
            if (item.listStyle === 'listImage') {
                setStyleAttribute(node, { 'list-style-image': item.listImage });
            }
            else {
                setStyleAttribute(node, { 'list-style-image': 'none' });
                var formattedStyle = this.formatListStyle(item.listStyle);
                setStyleAttribute(node, { 'list-style-type': formattedStyle });
            }
        }
    };
    /*
     * Transfers attributes from source element to target element
     */
    Lists.prototype.transferAttributes = function (sourceList, targetList) {
        for (var j = 0; j < sourceList.attributes.length; j++) {
            var attr = sourceList.attributes[j];
            targetList.setAttribute(attr.name, attr.value);
        }
    };
    Lists.prototype.cleanNode = function () {
        var liParents = this.parent.editableElement.querySelectorAll('ol + ol, ul + ul');
        var listStyleType;
        var firstNodeOL;
        for (var c = 0; c < liParents.length; c++) {
            var node = liParents[c];
            var toFindtopOlUl = true;
            var containsListElements = node;
            while (containsListElements.parentElement) {
                if (containsListElements.parentElement && containsListElements.parentElement.tagName !== 'LI' && containsListElements.parentElement.tagName !== 'OL' && containsListElements.parentElement.tagName !== 'UL') {
                    break;
                }
                containsListElements = containsListElements.parentElement;
            }
            if (toFindtopOlUl && (liParents[c].parentElement.parentElement.nodeName === 'OL' || liParents[c].parentElement.parentElement.nodeName === 'UL')) {
                toFindtopOlUl = false;
                var preElement = liParents[c].parentElement.parentElement;
                listStyleType = preElement.style.listStyleType;
                firstNodeOL = node.previousElementSibling;
            }
            // Check if the current node is part of the same list structure as its previous sibling
            var isSameList = this.domNode.isList(node.previousElementSibling) && node.parentElement === node.previousElementSibling.parentElement && node.parentElement.tagName === 'LI';
            if (this.domNode.isList(node.previousElementSibling) &&
                (this.domNode.openTagString(node) === this.domNode.openTagString(node.previousElementSibling)) || isSameList) {
                var contentNodes = this.domNode.contents(node);
                for (var f = 0; f < contentNodes.length; f++) {
                    node.previousElementSibling.appendChild(contentNodes[f]);
                }
                node.parentNode.removeChild(node);
            }
            else if (!isNOU(node.getAttribute('level'))) {
                if (node.tagName === node.previousElementSibling.tagName) {
                    node.previousElementSibling.lastChild.append(node);
                }
            }
            else if (this.domNode.isList(node.previousElementSibling) && containsListElements.contains(node.previousElementSibling) && ((node.tagName === 'OL' || node.tagName === 'UL') && (node.previousElementSibling.nodeName === 'OL' || node.previousElementSibling.nodeName === 'UL')) &&
                ((node.previousElementSibling.classList.contains('e-rte-checklist') && node.classList.contains('e-rte-checklist')) && !(node.previousElementSibling.classList.contains('e-rte-checklist') && node.classList.contains('e-rte-checklist')))) {
                var contentNodes = this.domNode.contents(node);
                for (var f = 0; f < contentNodes.length; f++) {
                    node.previousElementSibling.appendChild(contentNodes[f]);
                }
                node.parentNode.removeChild(node);
            }
        }
        if (firstNodeOL) {
            firstNodeOL.style.listStyleType = listStyleType;
            var range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            var listOlUlElements = [];
            if (range.commonAncestorContainer.nodeName === 'UL' || range.commonAncestorContainer.nodeName === 'OL') {
                if (range.commonAncestorContainer instanceof Element) {
                    listOlUlElements.push(range.commonAncestorContainer);
                }
                listOlUlElements = listOlUlElements.concat(Array.from(range.commonAncestorContainer.querySelectorAll('ol, ul')));
            }
            else {
                listOlUlElements = Array.from(range.commonAncestorContainer.querySelectorAll('ol, ul'));
            }
            for (var k = 0; k < listOlUlElements.length; k++) {
                var listStyle = void 0;
                var listElements = listOlUlElements[k];
                while (listElements) {
                    if (listElements.nodeName === 'OL' || listElements.nodeName === 'OL') {
                        if (listElements.style.listStyleType !== '' && listElements.style.listStyleType !== 'none' && listElements.nodeName !== 'LI') {
                            listStyle = listElements.style.listStyleType;
                        }
                        else if (!isNOU(listStyle) && (listElements.style.listStyleType === '' || listElements.style.listStyleType === 'none') &&
                            listElements.nodeName !== 'LI' && (listElements.nodeName === 'UL' || listElements.nodeName === 'OL')) {
                            listElements.style.listStyleType = listStyle;
                        }
                    }
                    listElements = listElements.querySelector('UL,OL');
                }
            }
        }
    };
    Lists.prototype.findUnSelected = function (temp, elements) {
        temp = temp.slice().reverse();
        if (temp.length > 0) {
            var rightIndent = [];
            var indentElements = [];
            var lastElement = elements[elements.length - 1];
            var lastElementChild = [];
            var childElements = [];
            lastElementChild = (lastElement.childNodes);
            for (var z = 0; z < lastElementChild.length; z++) {
                if (lastElementChild[z].tagName === 'OL' || lastElementChild[z].tagName === 'UL') {
                    var childLI = lastElementChild[z]
                        .querySelectorAll('li');
                    if (childLI.length > 0) {
                        for (var y = 0; y < childLI.length; y++) {
                            childElements.push(childLI[y]);
                        }
                    }
                }
            }
            for (var i = 0; i < childElements.length; i++) {
                var count = 0;
                for (var j = 0; j < temp.length; j++) {
                    if (!childElements[i].contains((temp[j]))) {
                        count = count + 1;
                    }
                }
                if (count === temp.length) {
                    indentElements.push(childElements[i]);
                }
            }
            if (indentElements.length > 0) {
                for (var x = 0; x < indentElements.length; x++) {
                    if (this.domNode.contents(indentElements[x])[0].nodeName !== 'OL' &&
                        this.domNode.contents(indentElements[x])[0].nodeName !== 'UL') {
                        rightIndent.push(indentElements[x]);
                    }
                }
            }
            if (rightIndent.length > 0) {
                this.nestedList(rightIndent);
            }
        }
    };
    Lists.prototype.revertChecklistItem = function (li) {
        if (li && li.parentElement && li.parentElement.classList.contains('e-rte-checklist')) {
            li.parentElement.classList.remove('e-rte-checklist');
        }
        if (li && li.classList.contains('e-rte-checklist-checked')) {
            li.classList.remove('e-rte-checklist-checked');
        }
    };
    // This method checks if a given tag name is a list-related element (UL, OL, or LI).
    Lists.prototype.isListTag = function (elementName) {
        return elementName === 'OL' || elementName === 'UL' || elementName === 'LI';
    };
    // This method inserts closing tags for all ancestor lists above a selected list item until reaching the specified main list, ensuring proper HTML structure.
    Lists.prototype.closeAncestorsBeforeSelection = function (selectionLi, parentOfMainUlorOL) {
        var parentOfSelectionLi = selectionLi.parentElement;
        var insertBeforElement = selectionLi;
        while (this.isListTag(selectionLi.parentElement.nodeName) && selectionLi.parentElement !== parentOfMainUlorOL) {
            parentOfSelectionLi.insertBefore(this.closeTag(selectionLi.parentElement.nodeName), insertBeforElement);
            selectionLi = selectionLi.parentElement;
        }
    };
    // This method inserts closing tags for list elements after the end of a selection, climbing up until the common parent or main list, then reopens the list structure to maintain valid HTML.
    Lists.prototype.closeAncestorsAfterSelection = function (endElement, endSelectionLi, startLi, endLi, parentOfMainUlorOL) {
        var endInsertAfterElement = endElement;
        this.domNode.insertAfter(this.closeTag(endSelectionLi.nodeName), endInsertAfterElement);
        endInsertAfterElement = endInsertAfterElement.nextSibling;
        var endSelectionElement = endSelectionLi.parentElement;
        var allClosed = false;
        if (startLi !== endLi) {
            // Close until we reach the common parent with the start LI
            if (endSelectionElement === startLi.parentElement || endSelectionElement === parentOfMainUlorOL) {
                allClosed = true;
            }
            while (!allClosed) {
                this.domNode.insertAfter(this.closeTag(endSelectionElement.nodeName), endInsertAfterElement);
                endInsertAfterElement = endInsertAfterElement.nextSibling;
                endSelectionElement = endSelectionElement.parentElement;
                if (endSelectionElement === startLi.parentElement || endSelectionElement === parentOfMainUlorOL) {
                    allClosed = true;
                }
            }
        }
        this.reopenListStructure(endSelectionLi, endInsertAfterElement, parentOfMainUlorOL);
    };
    // This method inserts opening tags for ancestor lists after a selection to restore the original nested list structure and adjusts classes for proper formatting.
    Lists.prototype.reopenListStructure = function (endSelectionLi, endInsertAfterElement, parentOfMainUlorOL) {
        while (this.isListTag(endSelectionLi.parentElement.nodeName) && endSelectionLi.parentElement !== parentOfMainUlorOL) {
            this.domNode.insertAfter(this.openTag(endSelectionLi.parentElement.nodeName), endInsertAfterElement);
            endSelectionLi = endSelectionLi.parentElement;
            endInsertAfterElement = endInsertAfterElement.nextSibling;
            var closeClasses = ['e-rte-list-close-li', 'e-rte-list-close-ol', 'e-rte-list-close-ul'];
            var openClasses = ['e-rte-list-open-ol', 'e-rte-list-open-ul'];
            var hasCloseClass = endInsertAfterElement.previousElementSibling &&
                closeClasses.indexOf(endInsertAfterElement.previousElementSibling.classList[0]) > -1;
            var hasOpenClass = openClasses.indexOf(endInsertAfterElement.classList[0]) > -1;
            if (hasCloseClass && hasOpenClass) {
                // To mark the beginning of a reopened list structure after a selection operation. This class is added
                endInsertAfterElement.classList.add('e-rte-list-start');
            }
        }
    };
    // This Method completely revert the selected List items
    Lists.prototype.completeRevertList = function (elements, enterAction) {
        if (enterAction === void 0) { enterAction = 'P'; }
        for (var i = 0; i < elements.commonList.length; i++) {
            // Find the top-most UL/OL/LI ancestor that owns the selection
            var mainParentULorOL = elements.commonListParent[i];
            var classListOfMainUlorOl = mainParentULorOL.getAttribute('class');
            var styleListOfMainUlorOl = mainParentULorOL.getAttribute('style');
            var parentOfMainUlorOL = mainParentULorOL.parentElement;
            // Locate selection start and normalize to its LI container
            var startElement = mainParentULorOL.querySelector('.e-editor-select-start');
            var selectionLi = startElement ? startElement.parentElement : null;
            if (isNOU(selectionLi)) {
                selectionLi = elements.commonList[i];
            }
            while (selectionLi && selectionLi.nodeName !== 'LI') {
                selectionLi = selectionLi.parentElement;
            }
            selectionLi.classList.add('e-rte-select-list-start');
            var startLi = selectionLi;
            this.closeAncestorsBeforeSelection(selectionLi, parentOfMainUlorOL);
            // Locate selection end marker; fallback to start if missing
            var endElement = mainParentULorOL.querySelector('.e-editor-select-end');
            if (isNullOrUndefined(endElement) && elements.commonList.length === 1) {
                endElement = startElement;
            }
            // Normalize to the containing LI for the end marker
            var endSelectionLi = endElement ? endElement.parentElement : null;
            if (isNOU(endSelectionLi)) {
                endSelectionLi = mainParentULorOL.lastElementChild;
                endElement = endSelectionLi.childNodes[endSelectionLi.childNodes.length - 1];
            }
            while (endSelectionLi.nodeName !== 'LI') {
                endSelectionLi = endSelectionLi.parentElement;
            }
            endSelectionLi.classList.add('e-rte-select-list-end');
            var endLi = endSelectionLi;
            // Expand endElement to the nearest block boundary, then to the last inline sibling in that block
            while (!this.parent.domNode.isBlockNode(endElement)) {
                if (endElement.parentElement.tagName !== 'LI') {
                    endElement = endElement.parentElement;
                }
                else {
                    break;
                }
            }
            while (endElement.nextSibling && !this.isListTag(endElement.nextSibling.nodeName)) {
                endElement = endElement.nextSibling;
            }
            if (endElement.nodeName === 'TD' || endElement.nodeName === 'TH') {
                endElement = endLi.childNodes[endLi.childNodes.length - 1];
                while (endElement && this.isListTag(endElement.nodeName)) {
                    endElement = endElement.previousSibling;
                }
            }
            this.closeAncestorsAfterSelection(endElement, endSelectionLi, startLi, endLi, parentOfMainUlorOL);
            mainParentULorOL.outerHTML = this.processSplitedList(this.replaceCustomSpans(mainParentULorOL.outerHTML, classListOfMainUlorOl, styleListOfMainUlorOl), enterAction);
        }
    };
    // This method merges new attributes into an element, avoids duplicates for class and style, removes unnecessary classes and list-related styles, and cleans up empty attributes.
    Lists.prototype.addAllAttributes = function (element, attributes) {
        Object.keys(attributes).forEach(function (key) {
            var newValue = attributes[key];
            // Check if the attribute already exists
            var existingValue = element.getAttribute(key);
            if (existingValue) {
                // Merge values for attributes like class, style, etc.
                if (key === 'class' || key === 'style') {
                    // Avoid duplicate values
                    var mergedValue = Array.from(new Set((existingValue + ' ' + newValue).trim().split(/\s+/))).join(' ');
                    element.setAttribute(key, mergedValue);
                }
                else {
                    // For other attributes, you can decide to overwrite or merge based on your needs
                    element.setAttribute(key, newValue); // Overwrite by default
                }
            }
            else {
                // If attribute doesn't exist, just set it
                element.setAttribute(key, newValue);
            }
        });
        var classesToRemove = ['e-rte-checklist', 'e-rte-select-list-start', 'e-rte-select-list-end', 'e-rte-checklist-checked'];
        var classRemoved = false;
        classesToRemove.forEach(function (cls) {
            if (element.classList.contains(cls)) {
                element.classList.remove(cls);
                classRemoved = true;
            }
        });
        // Remove 'class' attribute if no classes remain
        if (classRemoved && element.classList.length === 0) {
            element.removeAttribute('class');
        }
        if (element.style) {
            var styles = element.style;
            for (var i = 0; i < styles.length; i++) {
                if (styles[i] === 'list-style-image' || styles[i] === 'list-style-type') {
                    element.style.removeProperty(styles[i]);
                    i--;
                }
            }
            if (element.style.length === 0) {
                element.removeAttribute('style');
            }
        }
    };
    // This method processes a split list by wrapping selected items, preserving attributes, cleaning up empty lists, and applying styles before returning the updated HTML content.
    Lists.prototype.processSplitedList = function (content, enterAction) {
        var tempElement = createElement('div');
        tempElement.innerHTML = content;
        var startLi = tempElement.querySelector('.e-rte-select-list-start');
        var startElement = startLi;
        var mainUlOlAttributes;
        if (startLi.previousElementSibling && (startLi.previousElementSibling.nodeName === 'OL' || startLi.previousElementSibling.nodeName === 'UL')) {
            mainUlOlAttributes = this.extractAllAttributes(startLi.previousElementSibling);
        }
        if (startLi) {
            // Adding the class for processing the list element
            startLi.classList.add('e-rte-insertAfterElement');
            this.wrapperAction(startLi, enterAction, tempElement, mainUlOlAttributes);
            startElement = startLi.nextElementSibling;
            detach(startLi);
        }
        while (startElement && !(startElement.nodeName === 'OL' || startElement.nodeName === 'UL')) {
            if (startElement.nodeName === 'LI') {
                startElement.classList.add('e-rte-insertAfterElement');
                this.wrapperAction(startElement, enterAction, tempElement, mainUlOlAttributes);
                var nextLi = startElement.nextElementSibling;
                detach(startElement);
                startElement = nextLi;
            }
            else {
                startElement = startElement.nextElementSibling;
            }
        }
        if (startElement.classList.contains('e-rte-checklist')) {
            var ulList = startElement.querySelectorAll('ul');
            for (var i = 0; i < ulList.length; i++) {
                ulList[i].classList.add('e-rte-checklist');
            }
            var liElements = startElement.querySelectorAll('li');
            for (var i = 0; i < liElements.length; i++) {
                if (liElements[i].style.listStyleType === 'none') {
                    liElements[i].classList.add('e-rte-checklist-hidden');
                }
            }
        }
        var element = tempElement.querySelector('.e-rte-insertAfterElement');
        if (element) {
            element.classList.remove('e-rte-insertAfterElement');
            var classAttribute = element.getAttribute('class');
            if (!classAttribute) {
                element.removeAttribute('class');
            }
        }
        // Adding style for nested list of lastly splitted list elements
        this.addStyleForNestedList(tempElement);
        this.clearEmptyList(tempElement);
        return tempElement.innerHTML.trim();
    };
    // This method applies the style of the last nested list to its parent list element if the parent lacks that style, ensuring consistent formatting for deeply nested lists.
    Lists.prototype.addStyleForNestedList = function (tempElement) {
        if (tempElement.lastElementChild && (tempElement.lastElementChild.nodeName === 'OL' || tempElement.lastElementChild.nodeName === 'UL')) {
            var lastItem = tempElement.lastElementChild.firstElementChild;
            var textNode = !isNOU(lastItem) ? this.getFirstTextNode(lastItem) : null;
            if (!isNOU(textNode)) {
                var parentOfTextNode = textNode.parentNode;
                if (parentOfTextNode.nodeName !== 'OL' && parentOfTextNode.nodeName !== 'UL') {
                    while (parentOfTextNode && parentOfTextNode.nodeName !== 'LI') {
                        parentOfTextNode = parentOfTextNode.parentElement;
                    }
                    parentOfTextNode = parentOfTextNode.parentElement;
                }
                var styles = lastItem.parentElement.getAttribute('style');
                if ((!parentOfTextNode.getAttribute('style') || !parentOfTextNode.getAttribute('style').includes(styles)) && !isNOU(styles)) {
                    parentOfTextNode.setAttribute('style', styles);
                }
            }
        }
    };
    // This method removes empty <ul>, <ol>, and <li> elements from the container unless they contain media elements, ensuring clean and valid HTML structure.
    Lists.prototype.clearEmptyList = function (tempElement) {
        var emptyListElements = tempElement.querySelectorAll('ul, ol');
        for (var i = 0; i < emptyListElements.length; i++) {
            var element = emptyListElements[i];
            var hasMediaElem = element.querySelector('img, video, audio, table');
            var isEmptyText = element.textContent.trim() === '';
            if (isEmptyText && !hasMediaElem) {
                detach(element);
            }
        }
        var emptyList = tempElement.querySelectorAll('li:empty');
        for (var i = 0; i < emptyList.length; i++) {
            detach(emptyList[i]);
        }
    };
    // This method moves the marker class from the current element to its next sibling, ensuring the correct position for subsequent insertions.
    Lists.prototype.updateInsertAfterMarker = function (marker) {
        var nextElement = marker.nextElementSibling;
        marker.classList.remove('e-rte-insertAfterElement');
        var classAttribute = marker.getAttribute('class');
        if (!classAttribute) {
            marker.removeAttribute('class');
        }
        if (nextElement) {
            nextElement.classList.add('e-rte-insertAfterElement');
        }
    };
    // This method appends collected inline nodes into a wrapper element (or inserts them with a <br> if needed), places it after the marker in the container, and resets the inline node list.
    Lists.prototype.flushWrap = function (wrapElement, inlineNodes, container) {
        if (inlineNodes.length === 0) {
            return [];
        }
        if (wrapElement.nodeName !== 'BR') {
            for (var i = 0; i < inlineNodes.length; i++) {
                wrapElement.appendChild(inlineNodes[i]);
            }
            if (wrapElement.innerHTML.trim() !== '') {
                var marker = container.querySelector('.e-rte-insertAfterElement');
                if (marker) {
                    this.domNode.insertAfter(wrapElement, marker);
                    this.updateInsertAfterMarker(marker);
                }
            }
        }
        else {
            var marker = container.querySelector('.e-rte-insertAfterElement');
            var needToinsertBr = false;
            for (var i = 0; i < inlineNodes.length; i++) {
                if (inlineNodes[i].textContent.trim() !== '') {
                    container.insertBefore(inlineNodes[i], marker);
                    needToinsertBr = true;
                }
            }
            if (needToinsertBr) {
                container.insertBefore(wrapElement, marker);
            }
        }
        return [];
    };
    // This method creates a new wrapper element based on the specified tag (enterAction), applies attributes from the main list and the current element, and returns it for use in wrapping content.
    Lists.prototype.createWrapElement = function (enterAction, mainUlOlAttributes, element) {
        var wrapElement = createElement(enterAction);
        if (wrapElement.nodeName !== 'BR') {
            if (!isNOU(mainUlOlAttributes)) {
                this.applyAllAttributes(wrapElement, mainUlOlAttributes);
            }
            var allAttributes = this.extractAllAttributes(element);
            this.addAllAttributes(wrapElement, allAttributes);
        }
        if (wrapElement.getAttribute('style')) {
            var removableStyles = ['color', 'font-size', 'font-family', 'font-weight', 'font-style'];
            removableStyles.forEach(function (prop) {
                if (wrapElement.style.getPropertyValue(prop)) {
                    wrapElement.style.removeProperty(prop);
                }
            });
            // Remove the style attribute if no styles remain
            if (wrapElement.style.length === 0) {
                wrapElement.removeAttribute('style');
            }
        }
        return wrapElement;
    };
    // This method processes the child nodes of a list item, wrapping inline content into blocks, handling nested lists recursively, and preserving attributes for proper structure and formatting.
    Lists.prototype.wrapperAction = function (element, enterAction, tempElement, mainUlOlAttributes) {
        var childNodes = Array.from(element.childNodes);
        var inlineNodes = [];
        for (var i = 0; i < childNodes.length; i++) {
            var node = childNodes[i];
            if (node.nodeType === Node.ELEMENT_NODE) {
                var liChildNodes = node;
                if (this.domNode.isBlockNode(liChildNodes) && !this.isListTag(liChildNodes.nodeName)) {
                    // Output collected inline nodes as a wrapped block, then emit the block element
                    var wrapElement_1 = this.createWrapElement(enterAction, mainUlOlAttributes, element);
                    inlineNodes = this.flushWrap(wrapElement_1, inlineNodes, tempElement);
                    var marker = tempElement.querySelector('.e-rte-insertAfterElement');
                    if (marker) {
                        if (liChildNodes.innerHTML.trim() !== '' || liChildNodes.nodeName === 'HR') {
                            if (!isNOU(mainUlOlAttributes)) {
                                this.addAllAttributes(liChildNodes, mainUlOlAttributes);
                            }
                            var parentLi = liChildNodes.parentElement;
                            while (parentLi && parentLi.nodeName !== 'LI' && parentLi.nodeName !== 'OL' && parentLi.nodeName !== 'UL') {
                                parentLi = parentLi.parentElement;
                            }
                            var allAttributes = this.extractAllAttributes(parentLi);
                            this.addAllAttributes(liChildNodes, allAttributes);
                            this.domNode.insertAfter(liChildNodes, marker);
                            this.updateInsertAfterMarker(marker);
                        }
                    }
                }
                else if (this.isListTag(liChildNodes.nodeName)) {
                    // Finish current inline run, then recurse into nested lists
                    var wrapElement_2 = this.createWrapElement(enterAction, mainUlOlAttributes, element);
                    inlineNodes = this.flushWrap(wrapElement_2, inlineNodes, tempElement);
                    this.wrapperAction(liChildNodes, enterAction, tempElement, mainUlOlAttributes);
                }
                else {
                    inlineNodes.push(node);
                }
            }
            else {
                inlineNodes.push(node);
            }
        }
        // Flush any remaining inline nodes
        var wrapElement = this.createWrapElement(enterAction, mainUlOlAttributes, element);
        this.flushWrap(wrapElement, inlineNodes, tempElement);
    };
    // This method replaces placeholder <span> tags in the input string with actual <ul>, <ol>, and <li> tags, applying optional classes and styles for proper list rendering.
    Lists.prototype.replaceCustomSpans = function (input, mainListClass, mainListStyle) {
        var hasStyle = !isNOU(mainListStyle);
        var hasClass = !isNOU(mainListClass);
        var openUlReplacement = '<ul';
        if (hasClass) {
            openUlReplacement += ' class="' + mainListClass + '"';
        }
        if (hasStyle) {
            openUlReplacement += ' style="' + mainListStyle + '"';
        }
        openUlReplacement += '>';
        var openOlReplacement = '<ol';
        if (hasClass) {
            openOlReplacement += ' class="' + mainListClass + '"';
        }
        if (hasStyle) {
            openOlReplacement += ' style="' + mainListStyle + '"';
        }
        openOlReplacement += '>';
        var openLiReplacement = (!isNOU(mainListClass) && mainListClass.indexOf('e-rte-checklist-hidden') >= 0) ? '<li class="e-rte-checklist-hidden" style="list-style-type: none;">' : '<li style="list-style-type: none;">';
        var replacements = [
            {
                pattern: /<span class="e-rte-list-close-ul"><\/span>/g,
                replacement: '</ul>'
            },
            {
                pattern: /<span class="e-rte-list-close-li"><\/span>/g,
                replacement: '</li>'
            },
            {
                pattern: /<span class="e-rte-list-close-ol"><\/span>/g,
                replacement: '</ol>'
            },
            {
                pattern: /<span class="e-rte-list-open-ul e-rte-list-start"><\/span>/g,
                replacement: openUlReplacement
            },
            {
                pattern: /<span class="e-rte-list-open-ol e-rte-list-start"><\/span>/g,
                replacement: openOlReplacement
            },
            {
                pattern: /<span class="e-rte-list-open-ul"><\/span>/g,
                replacement: '<ul>'
            },
            {
                pattern: /<span class="e-rte-list-open-li"><\/span>/g,
                replacement: openLiReplacement
            },
            {
                pattern: /<span class="e-rte-list-open-ol"><\/span>/g,
                replacement: '<ol>'
            }
        ];
        var output = input;
        for (var i = 0; i < replacements.length; i++) {
            output = output.replace(replacements[i].pattern, replacements[i].replacement);
        }
        return output;
    };
    Lists.prototype.revertList = function (elements, e) {
        var temp = [];
        for (var i = elements.length - 1; i >= 0; i--) {
            for (var j = i - 1; j >= 0; j--) {
                if (elements[j].contains((elements[i])) || elements[j] === elements[i]) {
                    temp.push(elements[i]);
                    elements.splice(i, 1);
                    break;
                }
            }
        }
        this.findUnSelected(temp, elements);
        var viewNode = [];
        var _loop_5 = function (i) {
            var element = elements[i];
            if (this_4.domNode.contents(element)[0].nodeType === 3 && this_4.domNode.contents(element)[0].textContent.trim().length === 0) {
                detach(this_4.domNode.contents(element)[0]);
            }
            var parentNode = elements[i].parentNode;
            var className = element.getAttribute('class');
            if (temp.length === 0) {
                var siblingList = elements[i].querySelectorAll('ul, ol');
                var firstNode = siblingList[0];
                if (firstNode) {
                    var child = firstNode
                        .querySelectorAll('li');
                    if (child) {
                        var nestedElement = createElement(firstNode.tagName);
                        append([nestedElement], firstNode.parentNode);
                        var nestedElementLI = createElement('li', { styles: 'list-style-type: none;' });
                        append([nestedElementLI], nestedElement);
                        append([firstNode], nestedElementLI);
                    }
                }
            }
            if (element.parentNode.insertBefore(this_4.closeTag(parentNode.tagName), element),
                'LI' === parentNode.parentNode.tagName || 'OL' === parentNode.parentNode.tagName ||
                    'UL' === parentNode.parentNode.tagName) {
                element.parentNode.insertBefore(this_4.closeTag('LI'), element);
            }
            else {
                var classAttr = '';
                if (className) {
                    // eslint-disable-next-line
                    classAttr += ' class="' + className + '"';
                }
                var closestListMargin = this_4.getClosestListParentMargin(element);
                if (CONSTANT.DEFAULT_TAG && 0 === element.querySelectorAll(CONSTANT.BLOCK_TAGS.join(', ')).length) {
                    var wrapperclass = isNullOrUndefined(className) ? ' class="e-rte-wrap-inner"' :
                        ' class="' + className + ' e-rte-wrap-inner"';
                    var parentElement = parentNode;
                    if (elements.length === parentElement.querySelectorAll('li').length) {
                        if (!isNOU(parentElement.style.listStyleType)) {
                            parentNode.style.removeProperty('list-style-type');
                        }
                        if (!isNOU(parentElement.style.listStyleImage)) {
                            parentNode.style.removeProperty('list-style-image');
                        }
                        if (parentElement.style.length === 0) {
                            parentNode.removeAttribute('style');
                        }
                    }
                    var wrapperTag = isNullOrUndefined(e.enterAction) ? CONSTANT.DEFAULT_TAG : e.enterAction;
                    var targetElement_1 = element;
                    if (targetElement_1.getAttribute('style')) {
                        var removableStyles = ['color', 'font-size', 'font-family', 'font-weight', 'font-style'];
                        removableStyles.forEach(function (prop) {
                            if (targetElement_1.style.getPropertyValue(prop)) {
                                targetElement_1.style.removeProperty(prop);
                            }
                        });
                        // Remove the style attribute if no styles remain
                        if (targetElement_1.style.length === 0) {
                            targetElement_1.removeAttribute('style');
                        }
                    }
                    var wrapper = '<' + wrapperTag + wrapperclass + this_4.domNode.attributes(element) + '></' + wrapperTag + '>';
                    var tempElement = document.createElement('div');
                    tempElement.innerHTML = wrapper;
                    if (closestListMargin !== '') {
                        tempElement.firstElementChild.style.marginLeft = closestListMargin;
                    }
                    if (e.enterAction !== 'BR') {
                        this_4.domNode.wrapInner(element, this_4.domNode.parseHTMLFragment(tempElement.innerHTML));
                    }
                    else if (element.textContent !== '') {
                        var wrapperSpan = '<span class=e-rte-wrap-inner id=removeSpan></span>';
                        var br = document.createElement('br');
                        this_4.domNode.wrapInner(element, this_4.domNode.parseHTMLFragment(wrapperSpan));
                        element.appendChild(br);
                    }
                }
                else if (this_4.domNode.contents(element)[0].nodeType === 3) {
                    var replace = this_4.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, this_4.parent.domNode.encode(this_4.domNode.contents(element)[0].textContent));
                    this_4.domNode.replaceWith(this_4.domNode.contents(element)[0], replace);
                }
                else if (this_4.domNode.contents(element)[0].classList.contains(markerClassName.startSelection) ||
                    this_4.domNode.contents(element)[0].classList.contains(markerClassName.endSelection)) {
                    var replace = this_4.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, '<br>' + this_4.domNode.contents(element)[0].outerHTML);
                    if (this_4.domNode.contents(element)[1] && this_4.domNode.contents(element)[1].tagName === 'BR') {
                        this_4.domNode.contents(element)[1].remove();
                        replace = this_4.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, '<br>' + this_4.domNode.contents(element)[0].outerHTML);
                    }
                    else {
                        replace = this_4.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, this_4.domNode.contents(element)[0].outerHTML);
                    }
                    this_4.domNode.replaceWith(this_4.domNode.contents(element)[0], replace);
                }
                else {
                    var childNode = element.firstChild;
                    if (childNode) {
                        var attributes_1 = element.parentElement.attributes;
                        if (attributes_1.length > 0) {
                            for (var d = 0; d < attributes_1.length; d++) {
                                var e_1 = attributes_1[d];
                                var clean = function (v) {
                                    return v ? v.split(';').filter(function (s) { return !/list-style-(image|type):/.test(s.trim()); }).join(';').trim() : '';
                                };
                                var existingValue = clean(childNode.getAttribute(e_1.nodeName));
                                var parentValue = clean(element.parentElement.getAttribute(e_1.nodeName));
                                if (existingValue && existingValue !== parentValue) {
                                    childNode.setAttribute(e_1.nodeName, existingValue ? parentValue + ' ' + existingValue : parentValue);
                                }
                                else {
                                    childNode.setAttribute(e_1.nodeName, parentValue);
                                }
                                if (childNode.style.length === 0) {
                                    childNode.removeAttribute('style');
                                }
                            }
                        }
                    }
                    className = childNode.getAttribute('class');
                    if (className && childNode.getAttribute('class') && className !== childNode.getAttribute('class')) {
                        attributes(childNode, { 'class': className + ' ' + childNode.getAttribute('class') });
                    }
                }
                append([this_4.openTag('LI')], element);
                prepend([this_4.closeTag('LI')], element);
            }
            this_4.domNode.insertAfter(this_4.openTag(parentNode.tagName), element);
            if (parentNode.parentNode.tagName === 'LI') {
                parentNode = parentNode.parentNode.parentNode;
            }
            if (viewNode.indexOf(parentNode) < 0) {
                viewNode.push(parentNode);
            }
        };
        var this_4 = this;
        for (var i = 0; i < elements.length; i++) {
            _loop_5(i);
        }
        for (var i = 0; i < viewNode.length; i++) {
            var node = viewNode[i];
            var nodeInnerHtml = node.innerHTML;
            var closeTag = /<span class="e-rte-list-close-([a-z]*)"><\/span>/g;
            var openTag = /<span class="e-rte-list-open-([a-z]*)"><\/span>/g;
            nodeInnerHtml = nodeInnerHtml.replace(closeTag, '</$1>');
            nodeInnerHtml = nodeInnerHtml.replace(openTag, '<$1 ' + this.domNode.attributes(node) + '>');
            this.domNode.replaceWith(node, this.domNode.openTagString(node) + nodeInnerHtml.trim() + this.domNode.closeTagString(node));
        }
        var emptyUl = this.parent.editableElement.querySelectorAll('ul:empty, ol:empty');
        for (var i = 0; i < emptyUl.length; i++) {
            detach(emptyUl[i]);
        }
        var emptyLi = this.parent.editableElement.querySelectorAll('li:empty');
        for (var i = 0; i < emptyLi.length; i++) {
            detach(emptyLi[i]);
        }
        this.revertCheckListClasses();
    };
    Lists.prototype.revertCheckListClasses = function () {
        var searchContainer = this.parent.editableElement;
        var checkListElements = searchContainer.querySelectorAll('.e-rte-checklist');
        checkListElements.forEach(function (element) {
            if (element.nodeName !== 'UL' && element.classList.contains('e-rte-checklist')) {
                removeClass([element], ['e-rte-checklist']);
                if (element.getAttribute('class') === '') {
                    element.removeAttribute('class');
                }
            }
        });
        var checkedListContainers = searchContainer.querySelectorAll('.e-rte-checklist-checked');
        checkedListContainers.forEach(function (element) {
            if (element.nodeName !== 'LI') {
                removeClass([element], ['e-rte-checklist-checked']);
                if (element.getAttribute('class') === '') {
                    element.removeAttribute('class');
                }
            }
        });
    };
    Lists.prototype.getClosestListParentMargin = function (element) {
        var current = element;
        while (current && current !== this.parent.editableElement) {
            if (current.nodeName === 'UL' || current.nodeName === 'OL') {
                return current.style.marginLeft;
            }
            current = current.parentElement;
        }
        return '';
    };
    Lists.prototype.openTag = function (type) {
        return this.domNode.parseHTMLFragment('<span class="e-rte-list-open-' + type.toLowerCase() + '"></span>');
    };
    Lists.prototype.closeTag = function (type) {
        return this.domNode.parseHTMLFragment('<span class="e-rte-list-close-' + type.toLowerCase() + '"></span>');
    };
    Lists.prototype.destroy = function () {
        this.removeEventListener();
        if (this.domNode) {
            this.domNode = null;
        }
    };
    Lists.prototype.areAllListItemsSelected = function (list, range) {
        var listItems = list.querySelectorAll('li');
        for (var i = 0; i < listItems.length; i++) {
            var listItem = listItems[i];
            var listItemRange = this.parent.currentDocument.createRange();
            listItemRange.selectNodeContents(listItem);
            if (!range.intersectsNode(listItem)) {
                return false;
            }
        }
        return true;
    };
    Lists.prototype.getListCursorInfo = function (range) {
        var position;
        var selectionState;
        var domMethods = new DOMMethods(this.parent.editableElement);
        var startNode = range.startContainer.nodeType === Node.TEXT_NODE ?
            domMethods.getTopMostNode(range.startContainer) : range.startContainer;
        var endNode = range.endContainer.nodeType === Node.TEXT_NODE ?
            domMethods.getTopMostNode(range.endContainer) : range.endContainer;
        var isSelection = !range.collapsed;
        var startList = startNode.nodeType === Node.TEXT_NODE ? startNode.parentElement.closest('li') :
            startNode.closest('li');
        var endList = endNode.nodeType === Node.TEXT_NODE ? endNode.parentElement.closest('li') :
            endNode.closest('li');
        var isNestedStart = startList && startList.closest('ol, ul') ? this.checkIsNestedList(startList.closest('ol, ul')) : false;
        var isNestedEnd = endList && endList.closest('ol, ul') ? this.checkIsNestedList(endList.closest('ol, ul')) : false;
        var blockNodes = this.parent.domNode.blockNodes();
        var length = blockNodes.length;
        var itemType = this.getListSelectionType(isNestedStart ? 'Nested' : 'Parent', isNestedEnd ? 'Nested' : 'Parent');
        if (isSelection) {
            if (blockNodes.length === 1) {
                selectionState = range.startOffset === 0 && range.endOffset === startList.textContent.length ? 'SingleFull' : 'SinglePartial';
            }
            else {
                selectionState = range.startOffset === 0 && range.endOffset === blockNodes[length - 1].textContent.length ? 'MultipleFull' : 'MultiplePartial';
            }
            position = 'None';
        }
        else {
            if (range.startOffset === 0 && startNode.previousSibling === null) {
                position = isNestedStart ? 'StartNested' : 'StartParent';
            }
            else if (range.startOffset === startList.textContent.length && startNode.nextSibling === null) {
                position = isNestedStart ? 'EndNested' : 'EndParent';
            }
            else {
                position = isNestedStart ? 'MiddleNested' : 'MiddleParent';
            }
            selectionState = 'None';
        }
        return { position: position, selectionState: selectionState, itemType: itemType };
    };
    Lists.prototype.checkIsNestedList = function (listParent) {
        var isDirectParent = listParent.parentElement === this.parent.editableElement;
        if (isDirectParent) { // Check if the list is directly under the editable element.
            return false;
        }
        if (listParent.closest('li')) {
            return true;
        }
        return false;
    };
    Lists.prototype.getListSelectionType = function (start, end) {
        if (start === 'Nested' && end === 'Nested') {
            return 'Nested';
        }
        else if (start === 'Parent' && end === 'Parent') {
            return 'Parent';
        }
        else {
            return 'Mixed';
        }
    };
    Lists.prototype.isAllListNodesSelected = function (list) {
        var selection = this.parent.currentDocument.getSelection();
        var isAllSelected = false;
        var liNodes = list.querySelectorAll('li');
        for (var i = 0; i < liNodes.length; i++) {
            if (selection.containsNode(liNodes[i], false)) {
                isAllSelected = true;
            }
            else {
                isAllSelected = false;
                break;
            }
        }
        return isAllSelected;
    };
    Lists.prototype.formatListStyle = function (listStyle) {
        // Handle known lowercase patterns like "lowergreek"
        var knownPattern = /^(lower|upper)(greek|alpha|roman)$/i;
        if (knownPattern.test(listStyle)) {
            return listStyle.replace(knownPattern, function (_, p1, p2) { return p1 + "-" + p2; }).toLowerCase();
        }
        // Handle camelCase like "lowerGreek"
        return listStyle.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };
    return Lists;
}());
export { Lists };
